/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type CreateShowInput = {
  id?: string | null,
  name: string,
  owner?: string | null,
};

export type ModelShowConditionInput = {
  name?: ModelStringInput | null,
  version?: ModelIntInput | null,
  and?: Array< ModelShowConditionInput | null > | null,
  or?: Array< ModelShowConditionInput | null > | null,
  not?: ModelShowConditionInput | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type Show = {
  __typename: "Show",
  id: string,
  name: string,
  version: number,
  owner?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateShowInput = {
  id: string,
  name?: string | null,
  version?: number | null,
  owner?: string | null,
  expectedVersion: number,
};

export type DeleteShowInput = {
  id: string,
  expectedVersion: number,
};

export type CreateShowSettingInput = {
  id?: string | null,
  name?: string | null,
  title?: string | null,
  description?: string | null,
  slug?: string | null,
  startDateTime?: string | null,
  endDateTime?: string | null,
  status: Status,
  owner?: string | null,
  showID: string,
  showSettingOgpImageId?: string | null,
};

export enum Status {
  draft = "draft",
  publish = "publish",
  trash = "trash",
  private = "private",
}


export type ModelShowSettingConditionInput = {
  name?: ModelStringInput | null,
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  slug?: ModelStringInput | null,
  startDateTime?: ModelStringInput | null,
  endDateTime?: ModelStringInput | null,
  status?: ModelStatusInput | null,
  showID?: ModelIDInput | null,
  version?: ModelIntInput | null,
  and?: Array< ModelShowSettingConditionInput | null > | null,
  or?: Array< ModelShowSettingConditionInput | null > | null,
  not?: ModelShowSettingConditionInput | null,
};

export type ModelStatusInput = {
  eq?: Status | null,
  ne?: Status | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type ShowSetting = {
  __typename: "ShowSetting",
  id: string,
  name?: string | null,
  title?: string | null,
  description?: string | null,
  slug?: string | null,
  startDateTime?: string | null,
  endDateTime?: string | null,
  status: Status,
  owner?: string | null,
  showID: string,
  version: number,
  createdAt: string,
  updatedAt: string,
  ogpImage?: Image | null,
};

export type Image = {
  __typename: "Image",
  id: string,
  alternate: string,
  storage: S3Object,
  url: string,
  owner?: string | null,
  version: number,
  createdAt: string,
  updatedAt: string,
};

export type S3Object = {
  __typename: "S3Object",
  bucket: string,
  region: string,
  key: string,
};

export type UpdateShowSettingInput = {
  id: string,
  name?: string | null,
  title?: string | null,
  description?: string | null,
  slug?: string | null,
  startDateTime?: string | null,
  endDateTime?: string | null,
  status?: Status | null,
  owner?: string | null,
  showID?: string | null,
  version?: number | null,
  expectedVersion: number,
  showSettingOgpImageId?: string | null,
};

export type DeleteShowSettingInput = {
  id: string,
  expectedVersion: number,
};

export type CreateShowMainInput = {
  id?: string | null,
  title: string,
  mapDiscription?: string | null,
  logoDiscription?: string | null,
  discription?: string | null,
  section?: string | null,
  status: Status,
  showID: string,
  search?: boolean | null,
  owner?: string | null,
  showMainBackgroundImageId?: string | null,
};

export type ModelShowMainConditionInput = {
  title?: ModelStringInput | null,
  mapDiscription?: ModelStringInput | null,
  logoDiscription?: ModelStringInput | null,
  discription?: ModelStringInput | null,
  section?: ModelStringInput | null,
  status?: ModelStatusInput | null,
  showID?: ModelIDInput | null,
  search?: ModelBooleanInput | null,
  version?: ModelIntInput | null,
  and?: Array< ModelShowMainConditionInput | null > | null,
  or?: Array< ModelShowMainConditionInput | null > | null,
  not?: ModelShowMainConditionInput | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ShowMain = {
  __typename: "ShowMain",
  id: string,
  title: string,
  mapDiscription?: string | null,
  logoDiscription?: string | null,
  discription?: string | null,
  section?: string | null,
  status: Status,
  showID: string,
  search?: boolean | null,
  owner?: string | null,
  version: number,
  createdAt: string,
  updatedAt: string,
  backgroundImage?: Image | null,
};

export type UpdateShowMainInput = {
  id: string,
  title?: string | null,
  mapDiscription?: string | null,
  logoDiscription?: string | null,
  discription?: string | null,
  section?: string | null,
  status?: Status | null,
  showID?: string | null,
  search?: boolean | null,
  owner?: string | null,
  version?: number | null,
  expectedVersion: number,
  showMainBackgroundImageId?: string | null,
};

export type DeleteShowMainInput = {
  id: string,
  expectedVersion: number,
};

export type CreateTeaserInput = {
  id?: string | null,
  title: string,
  discription?: string | null,
  countDown?: boolean | null,
  section?: string | null,
  status: Status,
  showID: string,
  owner?: string | null,
  teaserBackgroundImageId?: string | null,
};

export type ModelTeaserConditionInput = {
  title?: ModelStringInput | null,
  discription?: ModelStringInput | null,
  countDown?: ModelBooleanInput | null,
  section?: ModelStringInput | null,
  status?: ModelStatusInput | null,
  showID?: ModelIDInput | null,
  version?: ModelIntInput | null,
  and?: Array< ModelTeaserConditionInput | null > | null,
  or?: Array< ModelTeaserConditionInput | null > | null,
  not?: ModelTeaserConditionInput | null,
};

export type Teaser = {
  __typename: "Teaser",
  id: string,
  title: string,
  discription?: string | null,
  countDown?: boolean | null,
  section?: string | null,
  status: Status,
  showID: string,
  owner?: string | null,
  version: number,
  createdAt: string,
  updatedAt: string,
  backgroundImage?: Image | null,
};

export type UpdateTeaserInput = {
  id: string,
  title?: string | null,
  discription?: string | null,
  countDown?: boolean | null,
  section?: string | null,
  status?: Status | null,
  showID?: string | null,
  owner?: string | null,
  version?: number | null,
  expectedVersion: number,
  teaserBackgroundImageId?: string | null,
};

export type DeleteTeaserInput = {
  id: string,
  expectedVersion: number,
};

export type CreatePageInput = {
  id?: string | null,
  root: string,
  slug: string,
  title: string,
  discription?: string | null,
  contents?: string | null,
  status: Status,
  owner?: string | null,
  pageBackgroundImageId?: string | null,
};

export type ModelPageConditionInput = {
  root?: ModelStringInput | null,
  slug?: ModelStringInput | null,
  title?: ModelStringInput | null,
  discription?: ModelStringInput | null,
  contents?: ModelStringInput | null,
  status?: ModelStatusInput | null,
  version?: ModelIntInput | null,
  and?: Array< ModelPageConditionInput | null > | null,
  or?: Array< ModelPageConditionInput | null > | null,
  not?: ModelPageConditionInput | null,
};

export type Page = {
  __typename: "Page",
  id: string,
  root: string,
  slug: string,
  title: string,
  discription?: string | null,
  contents?: string | null,
  status: Status,
  owner?: string | null,
  version: number,
  createdAt: string,
  updatedAt: string,
  backgroundImage?: Image | null,
};

export type UpdatePageInput = {
  id: string,
  root?: string | null,
  slug?: string | null,
  title?: string | null,
  discription?: string | null,
  contents?: string | null,
  status?: Status | null,
  owner?: string | null,
  version?: number | null,
  expectedVersion: number,
  pageBackgroundImageId?: string | null,
};

export type DeletePageInput = {
  id: string,
  expectedVersion: number,
};

export type CreateTopPageInput = {
  id?: string | null,
  title: string,
  discription?: string | null,
  contents?: string | null,
  owner?: string | null,
  topPageBackgroundImageId?: string | null,
};

export type ModelTopPageConditionInput = {
  title?: ModelStringInput | null,
  discription?: ModelStringInput | null,
  contents?: ModelStringInput | null,
  version?: ModelIntInput | null,
  and?: Array< ModelTopPageConditionInput | null > | null,
  or?: Array< ModelTopPageConditionInput | null > | null,
  not?: ModelTopPageConditionInput | null,
};

export type TopPage = {
  __typename: "TopPage",
  id: string,
  title: string,
  discription?: string | null,
  contents?: string | null,
  owner?: string | null,
  version: number,
  createdAt: string,
  updatedAt: string,
  backgroundImage?: Image | null,
};

export type UpdateTopPageInput = {
  id: string,
  title?: string | null,
  discription?: string | null,
  contents?: string | null,
  owner?: string | null,
  version?: number | null,
  expectedVersion: number,
  topPageBackgroundImageId?: string | null,
};

export type DeleteTopPageInput = {
  id: string,
  expectedVersion: number,
};

export type CreateShowBoothInput = {
  id?: string | null,
  name: string,
  title: string,
  discription?: string | null,
  section?: string | null,
  priority?: number | null,
  status: Status,
  showID: string,
  owner?: string | null,
  showBoothBackgroundImageId?: string | null,
  showBoothBrandLogosId?: string | null,
};

export type ModelShowBoothConditionInput = {
  name?: ModelStringInput | null,
  title?: ModelStringInput | null,
  discription?: ModelStringInput | null,
  section?: ModelStringInput | null,
  priority?: ModelIntInput | null,
  status?: ModelStatusInput | null,
  showID?: ModelIDInput | null,
  version?: ModelIntInput | null,
  and?: Array< ModelShowBoothConditionInput | null > | null,
  or?: Array< ModelShowBoothConditionInput | null > | null,
  not?: ModelShowBoothConditionInput | null,
};

export type ShowBooth = {
  __typename: "ShowBooth",
  id: string,
  name: string,
  title: string,
  discription?: string | null,
  section?: string | null,
  priority?: number | null,
  status: Status,
  showID: string,
  owner?: string | null,
  version: number,
  createdAt: string,
  updatedAt: string,
  brandLogos?: Album | null,
  backgroundImage?: Image | null,
};

export type Album = {
  __typename: "Album",
  id: string,
  name?: string | null,
  owner?: string | null,
  version: number,
  createdAt: string,
  updatedAt: string,
  phots?: ModelAlbumPhotConnection | null,
};

export type ModelAlbumPhotConnection = {
  __typename: "ModelAlbumPhotConnection",
  items:  Array<AlbumPhot | null >,
  nextToken?: string | null,
};

export type AlbumPhot = {
  __typename: "AlbumPhot",
  id: string,
  albumID: string,
  photID: string,
  albumOrder?: number | null,
  owner?: string | null,
  version: number,
  createdAt: string,
  updatedAt: string,
  album?: Album | null,
  phot?: Image | null,
};

export type UpdateShowBoothInput = {
  id: string,
  name?: string | null,
  title?: string | null,
  discription?: string | null,
  section?: string | null,
  priority?: number | null,
  status?: Status | null,
  showID?: string | null,
  owner?: string | null,
  version?: number | null,
  expectedVersion: number,
  showBoothBackgroundImageId?: string | null,
  showBoothBrandLogosId?: string | null,
};

export type DeleteShowBoothInput = {
  id: string,
  expectedVersion: number,
};

export type CreateShowBoothItemInput = {
  id?: string | null,
  name?: string | null,
  title?: string | null,
  readingName?: string | null,
  description?: string | null,
  keyword?: string | null,
  movie?: string | null,
  brand?: string | null,
  price?: number | null,
  boatType?: string | null,
  height?: number | null,
  capacity?: number | null,
  view360?: string | null,
  section?: string | null,
  productUrl?: string | null,
  mapPriority?: number | null,
  badge?: string | null,
  status: Status,
  boothID: string,
  showID: string,
  owner?: string | null,
  priority?: number | null,
  mapIndex?: number | null,
  boothIndex?: number | null,
  boothOrder?: number | null,
  mapOrder?: number | null,
  isExhibition?: boolean | null,
  showBoothItemMainImageId?: string | null,
  showBoothItemLogoId?: string | null,
  showBoothItemPhotoGalleryId?: string | null,
  showBoothItemMapIconId?: string | null,
  showBoothItemThumbnailId?: string | null,
};

export type ModelShowBoothItemConditionInput = {
  name?: ModelStringInput | null,
  title?: ModelStringInput | null,
  readingName?: ModelStringInput | null,
  description?: ModelStringInput | null,
  keyword?: ModelStringInput | null,
  movie?: ModelStringInput | null,
  brand?: ModelStringInput | null,
  price?: ModelFloatInput | null,
  boatType?: ModelStringInput | null,
  height?: ModelFloatInput | null,
  capacity?: ModelIntInput | null,
  view360?: ModelStringInput | null,
  section?: ModelStringInput | null,
  productUrl?: ModelStringInput | null,
  mapPriority?: ModelIntInput | null,
  badge?: ModelStringInput | null,
  status?: ModelStatusInput | null,
  boothID?: ModelIDInput | null,
  showID?: ModelIDInput | null,
  version?: ModelIntInput | null,
  priority?: ModelIntInput | null,
  mapIndex?: ModelIntInput | null,
  boothIndex?: ModelIntInput | null,
  boothOrder?: ModelIntInput | null,
  mapOrder?: ModelIntInput | null,
  isExhibition?: ModelBooleanInput | null,
  and?: Array< ModelShowBoothItemConditionInput | null > | null,
  or?: Array< ModelShowBoothItemConditionInput | null > | null,
  not?: ModelShowBoothItemConditionInput | null,
};

export type ModelFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ShowBoothItem = {
  __typename: "ShowBoothItem",
  id: string,
  name?: string | null,
  title?: string | null,
  readingName?: string | null,
  description?: string | null,
  keyword?: string | null,
  movie?: string | null,
  brand?: string | null,
  price?: number | null,
  boatType?: string | null,
  height?: number | null,
  capacity?: number | null,
  view360?: string | null,
  section?: string | null,
  productUrl?: string | null,
  mapPriority?: number | null,
  badge?: string | null,
  status: Status,
  boothID: string,
  showID: string,
  owner?: string | null,
  version: number,
  priority?: number | null,
  mapIndex?: number | null,
  boothIndex?: number | null,
  boothOrder?: number | null,
  mapOrder?: number | null,
  isExhibition?: boolean | null,
  createdAt: string,
  updatedAt: string,
  photoGallery?: Album | null,
  mainImage?: Image | null,
  logo?: Image | null,
  mapIcon?: Image | null,
  thumbnail?: Image | null,
};

export type UpdateShowBoothItemInput = {
  id: string,
  name?: string | null,
  title?: string | null,
  readingName?: string | null,
  description?: string | null,
  keyword?: string | null,
  movie?: string | null,
  brand?: string | null,
  price?: number | null,
  boatType?: string | null,
  height?: number | null,
  capacity?: number | null,
  view360?: string | null,
  section?: string | null,
  productUrl?: string | null,
  mapPriority?: number | null,
  badge?: string | null,
  status?: Status | null,
  boothID?: string | null,
  showID?: string | null,
  owner?: string | null,
  version?: number | null,
  priority?: number | null,
  mapIndex?: number | null,
  boothIndex?: number | null,
  boothOrder?: number | null,
  mapOrder?: number | null,
  isExhibition?: boolean | null,
  expectedVersion: number,
  showBoothItemMainImageId?: string | null,
  showBoothItemLogoId?: string | null,
  showBoothItemPhotoGalleryId?: string | null,
  showBoothItemMapIconId?: string | null,
  showBoothItemThumbnailId?: string | null,
};

export type DeleteShowBoothItemInput = {
  id: string,
  expectedVersion: number,
};

export type CreateBoothUserInfoInput = {
  id?: string | null,
  chatUrl?: string | null,
  chatStatus: Status,
  contactTel?: string | null,
  contactTelInfo?: string | null,
  contactEmail?: string | null,
  contactAddress?: string | null,
  web?: string | null,
  facebook?: string | null,
  boothID: string,
  owner?: string | null,
};

export type ModelBoothUserInfoConditionInput = {
  chatUrl?: ModelStringInput | null,
  chatStatus?: ModelStatusInput | null,
  contactTel?: ModelStringInput | null,
  contactTelInfo?: ModelStringInput | null,
  contactEmail?: ModelStringInput | null,
  contactAddress?: ModelStringInput | null,
  web?: ModelStringInput | null,
  facebook?: ModelStringInput | null,
  boothID?: ModelIDInput | null,
  version?: ModelIntInput | null,
  and?: Array< ModelBoothUserInfoConditionInput | null > | null,
  or?: Array< ModelBoothUserInfoConditionInput | null > | null,
  not?: ModelBoothUserInfoConditionInput | null,
};

export type BoothUserInfo = {
  __typename: "BoothUserInfo",
  id: string,
  chatUrl?: string | null,
  chatStatus: Status,
  contactTel?: string | null,
  contactTelInfo?: string | null,
  contactEmail?: string | null,
  contactAddress?: string | null,
  web?: string | null,
  facebook?: string | null,
  boothID: string,
  owner?: string | null,
  version: number,
  createdAt: string,
  updatedAt: string,
};

export type UpdateBoothUserInfoInput = {
  id: string,
  chatUrl?: string | null,
  chatStatus?: Status | null,
  contactTel?: string | null,
  contactTelInfo?: string | null,
  contactEmail?: string | null,
  contactAddress?: string | null,
  web?: string | null,
  facebook?: string | null,
  boothID?: string | null,
  owner?: string | null,
  version?: number | null,
  expectedVersion: number,
};

export type DeleteBoothUserInfoInput = {
  id: string,
  expectedVersion: number,
};

export type CreateAlbumInput = {
  id?: string | null,
  name?: string | null,
  owner?: string | null,
};

export type ModelAlbumConditionInput = {
  name?: ModelStringInput | null,
  version?: ModelIntInput | null,
  and?: Array< ModelAlbumConditionInput | null > | null,
  or?: Array< ModelAlbumConditionInput | null > | null,
  not?: ModelAlbumConditionInput | null,
};

export type UpdateAlbumInput = {
  id: string,
  name?: string | null,
  owner?: string | null,
  version?: number | null,
  expectedVersion: number,
};

export type DeleteAlbumInput = {
  id: string,
  expectedVersion: number,
};

export type CreateBoothBoatTypeInput = {
  id?: string | null,
  name: string,
  priority?: number | null,
  owner?: string | null,
};

export type ModelBoothBoatTypeConditionInput = {
  name?: ModelStringInput | null,
  priority?: ModelIntInput | null,
  version?: ModelIntInput | null,
  and?: Array< ModelBoothBoatTypeConditionInput | null > | null,
  or?: Array< ModelBoothBoatTypeConditionInput | null > | null,
  not?: ModelBoothBoatTypeConditionInput | null,
};

export type BoothBoatType = {
  __typename: "BoothBoatType",
  id: string,
  name: string,
  priority?: number | null,
  owner?: string | null,
  version: number,
  createdAt: string,
  updatedAt: string,
};

export type UpdateBoothBoatTypeInput = {
  id: string,
  name?: string | null,
  priority?: number | null,
  owner?: string | null,
  version?: number | null,
  expectedVersion: number,
};

export type DeleteBoothBoatTypeInput = {
  id: string,
  expectedVersion: number,
};

export type CreateBoothBoatBrandInput = {
  id?: string | null,
  name: string,
  priority?: number | null,
  owner?: string | null,
};

export type ModelBoothBoatBrandConditionInput = {
  name?: ModelStringInput | null,
  priority?: ModelIntInput | null,
  version?: ModelIntInput | null,
  and?: Array< ModelBoothBoatBrandConditionInput | null > | null,
  or?: Array< ModelBoothBoatBrandConditionInput | null > | null,
  not?: ModelBoothBoatBrandConditionInput | null,
};

export type BoothBoatBrand = {
  __typename: "BoothBoatBrand",
  id: string,
  name: string,
  priority?: number | null,
  owner?: string | null,
  version: number,
  createdAt: string,
  updatedAt: string,
};

export type UpdateBoothBoatBrandInput = {
  id: string,
  name?: string | null,
  priority?: number | null,
  owner?: string | null,
  version?: number | null,
  expectedVersion: number,
};

export type DeleteBoothBoatBrandInput = {
  id: string,
  expectedVersion: number,
};

export type CreateAlbumPhotInput = {
  id?: string | null,
  albumID: string,
  photID: string,
  albumOrder?: number | null,
  owner?: string | null,
};

export type ModelAlbumPhotConditionInput = {
  albumID?: ModelIDInput | null,
  photID?: ModelIDInput | null,
  albumOrder?: ModelIntInput | null,
  version?: ModelIntInput | null,
  and?: Array< ModelAlbumPhotConditionInput | null > | null,
  or?: Array< ModelAlbumPhotConditionInput | null > | null,
  not?: ModelAlbumPhotConditionInput | null,
};

export type UpdateAlbumPhotInput = {
  id: string,
  albumID?: string | null,
  photID?: string | null,
  albumOrder?: number | null,
  owner?: string | null,
  version?: number | null,
  expectedVersion: number,
};

export type DeleteAlbumPhotInput = {
  id: string,
  expectedVersion: number,
};

export type CreateImageInput = {
  id?: string | null,
  alternate: string,
  storage: S3ObjectInput,
  url: string,
  owner?: string | null,
};

export type S3ObjectInput = {
  bucket: string,
  region: string,
  key: string,
};

export type ModelImageConditionInput = {
  alternate?: ModelStringInput | null,
  url?: ModelStringInput | null,
  version?: ModelIntInput | null,
  and?: Array< ModelImageConditionInput | null > | null,
  or?: Array< ModelImageConditionInput | null > | null,
  not?: ModelImageConditionInput | null,
};

export type UpdateImageInput = {
  id: string,
  alternate?: string | null,
  storage?: S3ObjectInput | null,
  url?: string | null,
  owner?: string | null,
  version?: number | null,
  expectedVersion: number,
};

export type DeleteImageInput = {
  id: string,
  expectedVersion: number,
};

export type CreateShowAudienceInput = {
  id?: string | null,
  showID: string,
  userID: string,
  owner?: string | null,
};

export type ModelShowAudienceConditionInput = {
  showID?: ModelIDInput | null,
  userID?: ModelIDInput | null,
  version?: ModelIntInput | null,
  and?: Array< ModelShowAudienceConditionInput | null > | null,
  or?: Array< ModelShowAudienceConditionInput | null > | null,
  not?: ModelShowAudienceConditionInput | null,
};

export type ShowAudience = {
  __typename: "ShowAudience",
  id: string,
  showID: string,
  userID: string,
  owner?: string | null,
  version: number,
  createdAt: string,
  updatedAt: string,
  show?: Show | null,
  users?: User | null,
};

export type User = {
  __typename: "User",
  id?: string | null,
  identity_id: string,
  email: string,
  group?: string | null,
  version: number,
  createdAt: string,
  updatedAt: string,
  tickets?: ModelTicketConnection | null,
};

export type ModelTicketConnection = {
  __typename: "ModelTicketConnection",
  items:  Array<Ticket | null >,
  nextToken?: string | null,
};

export type Ticket = {
  __typename: "Ticket",
  id?: string | null,
  status?: TicketStatus | null,
  group?: string | null,
  version: number,
  createdAt: string,
  updatedAt: string,
  activatedUser?: User | null,
};

export enum TicketStatus {
  NotActivate = "NotActivate",
  Activate = "Activate",
}


export type UpdateShowAudienceInput = {
  id: string,
  showID?: string | null,
  userID?: string | null,
  owner?: string | null,
  version?: number | null,
  expectedVersion: number,
};

export type DeleteShowAudienceInput = {
  id: string,
  expectedVersion: number,
};

export type CreateUserInput = {
  id?: string | null,
  identity_id: string,
  email: string,
  group?: string | null,
};

export type ModelUserConditionInput = {
  email?: ModelStringInput | null,
  group?: ModelStringInput | null,
  version?: ModelIntInput | null,
  and?: Array< ModelUserConditionInput | null > | null,
  or?: Array< ModelUserConditionInput | null > | null,
  not?: ModelUserConditionInput | null,
};

export type UpdateUserInput = {
  id?: string | null,
  identity_id: string,
  email?: string | null,
  group?: string | null,
  version?: number | null,
  expectedVersion: number,
};

export type DeleteUserInput = {
  identity_id: string,
  expectedVersion: number,
};

export type CreateTicketInput = {
  id?: string | null,
  status?: TicketStatus | null,
  group?: string | null,
  userTicketsId?: string | null,
  ticketActivatedUserId?: string | null,
};

export type ModelTicketConditionInput = {
  status?: ModelTicketStatusInput | null,
  group?: ModelStringInput | null,
  version?: ModelIntInput | null,
  and?: Array< ModelTicketConditionInput | null > | null,
  or?: Array< ModelTicketConditionInput | null > | null,
  not?: ModelTicketConditionInput | null,
};

export type ModelTicketStatusInput = {
  eq?: TicketStatus | null,
  ne?: TicketStatus | null,
};

export type UpdateTicketInput = {
  id: string,
  status?: TicketStatus | null,
  group?: string | null,
  version?: number | null,
  expectedVersion: number,
  userTicketsId?: string | null,
  ticketActivatedUserId?: string | null,
};

export type DeleteTicketInput = {
  id: string,
  expectedVersion: number,
};

export type ModelShowFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  version?: ModelIntInput | null,
  owner?: ModelStringInput | null,
  and?: Array< ModelShowFilterInput | null > | null,
  or?: Array< ModelShowFilterInput | null > | null,
  not?: ModelShowFilterInput | null,
};

export type ModelShowConnection = {
  __typename: "ModelShowConnection",
  items:  Array<Show | null >,
  nextToken?: string | null,
};

export type ModelShowSettingFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  slug?: ModelStringInput | null,
  startDateTime?: ModelStringInput | null,
  endDateTime?: ModelStringInput | null,
  status?: ModelStatusInput | null,
  owner?: ModelStringInput | null,
  showID?: ModelIDInput | null,
  version?: ModelIntInput | null,
  and?: Array< ModelShowSettingFilterInput | null > | null,
  or?: Array< ModelShowSettingFilterInput | null > | null,
  not?: ModelShowSettingFilterInput | null,
};

export type ModelShowSettingConnection = {
  __typename: "ModelShowSettingConnection",
  items:  Array<ShowSetting | null >,
  nextToken?: string | null,
};

export type ModelShowMainFilterInput = {
  id?: ModelIDInput | null,
  title?: ModelStringInput | null,
  mapDiscription?: ModelStringInput | null,
  logoDiscription?: ModelStringInput | null,
  discription?: ModelStringInput | null,
  section?: ModelStringInput | null,
  status?: ModelStatusInput | null,
  showID?: ModelIDInput | null,
  search?: ModelBooleanInput | null,
  owner?: ModelStringInput | null,
  version?: ModelIntInput | null,
  and?: Array< ModelShowMainFilterInput | null > | null,
  or?: Array< ModelShowMainFilterInput | null > | null,
  not?: ModelShowMainFilterInput | null,
};

export type ModelShowMainConnection = {
  __typename: "ModelShowMainConnection",
  items:  Array<ShowMain | null >,
  nextToken?: string | null,
};

export type ModelTeaserFilterInput = {
  id?: ModelIDInput | null,
  title?: ModelStringInput | null,
  discription?: ModelStringInput | null,
  countDown?: ModelBooleanInput | null,
  section?: ModelStringInput | null,
  status?: ModelStatusInput | null,
  showID?: ModelIDInput | null,
  owner?: ModelStringInput | null,
  version?: ModelIntInput | null,
  and?: Array< ModelTeaserFilterInput | null > | null,
  or?: Array< ModelTeaserFilterInput | null > | null,
  not?: ModelTeaserFilterInput | null,
};

export type ModelTeaserConnection = {
  __typename: "ModelTeaserConnection",
  items:  Array<Teaser | null >,
  nextToken?: string | null,
};

export type ModelPageFilterInput = {
  id?: ModelIDInput | null,
  root?: ModelStringInput | null,
  slug?: ModelStringInput | null,
  title?: ModelStringInput | null,
  discription?: ModelStringInput | null,
  contents?: ModelStringInput | null,
  status?: ModelStatusInput | null,
  owner?: ModelStringInput | null,
  version?: ModelIntInput | null,
  and?: Array< ModelPageFilterInput | null > | null,
  or?: Array< ModelPageFilterInput | null > | null,
  not?: ModelPageFilterInput | null,
};

export type ModelPageConnection = {
  __typename: "ModelPageConnection",
  items:  Array<Page | null >,
  nextToken?: string | null,
};

export type ModelTopPageFilterInput = {
  id?: ModelIDInput | null,
  title?: ModelStringInput | null,
  discription?: ModelStringInput | null,
  contents?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  version?: ModelIntInput | null,
  and?: Array< ModelTopPageFilterInput | null > | null,
  or?: Array< ModelTopPageFilterInput | null > | null,
  not?: ModelTopPageFilterInput | null,
};

export type ModelTopPageConnection = {
  __typename: "ModelTopPageConnection",
  items:  Array<TopPage | null >,
  nextToken?: string | null,
};

export type ModelShowBoothFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  title?: ModelStringInput | null,
  discription?: ModelStringInput | null,
  section?: ModelStringInput | null,
  priority?: ModelIntInput | null,
  status?: ModelStatusInput | null,
  showID?: ModelIDInput | null,
  owner?: ModelStringInput | null,
  version?: ModelIntInput | null,
  and?: Array< ModelShowBoothFilterInput | null > | null,
  or?: Array< ModelShowBoothFilterInput | null > | null,
  not?: ModelShowBoothFilterInput | null,
};

export type ModelShowBoothConnection = {
  __typename: "ModelShowBoothConnection",
  items:  Array<ShowBooth | null >,
  nextToken?: string | null,
};

export type ModelShowBoothItemFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  title?: ModelStringInput | null,
  readingName?: ModelStringInput | null,
  description?: ModelStringInput | null,
  keyword?: ModelStringInput | null,
  movie?: ModelStringInput | null,
  brand?: ModelStringInput | null,
  price?: ModelFloatInput | null,
  boatType?: ModelStringInput | null,
  height?: ModelFloatInput | null,
  capacity?: ModelIntInput | null,
  view360?: ModelStringInput | null,
  section?: ModelStringInput | null,
  productUrl?: ModelStringInput | null,
  mapPriority?: ModelIntInput | null,
  badge?: ModelStringInput | null,
  status?: ModelStatusInput | null,
  boothID?: ModelIDInput | null,
  showID?: ModelIDInput | null,
  owner?: ModelStringInput | null,
  version?: ModelIntInput | null,
  priority?: ModelIntInput | null,
  mapIndex?: ModelIntInput | null,
  boothIndex?: ModelIntInput | null,
  boothOrder?: ModelIntInput | null,
  mapOrder?: ModelIntInput | null,
  isExhibition?: ModelBooleanInput | null,
  and?: Array< ModelShowBoothItemFilterInput | null > | null,
  or?: Array< ModelShowBoothItemFilterInput | null > | null,
  not?: ModelShowBoothItemFilterInput | null,
};

export type ModelShowBoothItemConnection = {
  __typename: "ModelShowBoothItemConnection",
  items:  Array<ShowBoothItem | null >,
  nextToken?: string | null,
};

export type SearchableShowBoothItemFilterInput = {
  id?: SearchableIDFilterInput | null,
  name?: SearchableStringFilterInput | null,
  title?: SearchableStringFilterInput | null,
  readingName?: SearchableStringFilterInput | null,
  description?: SearchableStringFilterInput | null,
  keyword?: SearchableStringFilterInput | null,
  movie?: SearchableStringFilterInput | null,
  brand?: SearchableStringFilterInput | null,
  price?: SearchableFloatFilterInput | null,
  boatType?: SearchableStringFilterInput | null,
  height?: SearchableFloatFilterInput | null,
  capacity?: SearchableIntFilterInput | null,
  view360?: SearchableStringFilterInput | null,
  section?: SearchableStringFilterInput | null,
  productUrl?: SearchableStringFilterInput | null,
  mapPriority?: SearchableIntFilterInput | null,
  badge?: SearchableStringFilterInput | null,
  boothID?: SearchableIDFilterInput | null,
  showID?: SearchableIDFilterInput | null,
  owner?: SearchableStringFilterInput | null,
  version?: SearchableIntFilterInput | null,
  priority?: SearchableIntFilterInput | null,
  mapIndex?: SearchableIntFilterInput | null,
  boothIndex?: SearchableIntFilterInput | null,
  boothOrder?: SearchableIntFilterInput | null,
  mapOrder?: SearchableIntFilterInput | null,
  isExhibition?: SearchableBooleanFilterInput | null,
  and?: Array< SearchableShowBoothItemFilterInput | null > | null,
  or?: Array< SearchableShowBoothItemFilterInput | null > | null,
  not?: SearchableShowBoothItemFilterInput | null,
};

export type SearchableIDFilterInput = {
  ne?: string | null,
  gt?: string | null,
  lt?: string | null,
  gte?: string | null,
  lte?: string | null,
  eq?: string | null,
  match?: string | null,
  matchPhrase?: string | null,
  matchPhrasePrefix?: string | null,
  multiMatch?: string | null,
  exists?: boolean | null,
  wildcard?: string | null,
  regexp?: string | null,
  range?: Array< string | null > | null,
};

export type SearchableStringFilterInput = {
  ne?: string | null,
  gt?: string | null,
  lt?: string | null,
  gte?: string | null,
  lte?: string | null,
  eq?: string | null,
  match?: string | null,
  matchPhrase?: string | null,
  matchPhrasePrefix?: string | null,
  multiMatch?: string | null,
  exists?: boolean | null,
  wildcard?: string | null,
  regexp?: string | null,
  range?: Array< string | null > | null,
};

export type SearchableFloatFilterInput = {
  ne?: number | null,
  gt?: number | null,
  lt?: number | null,
  gte?: number | null,
  lte?: number | null,
  eq?: number | null,
  range?: Array< number | null > | null,
};

export type SearchableIntFilterInput = {
  ne?: number | null,
  gt?: number | null,
  lt?: number | null,
  gte?: number | null,
  lte?: number | null,
  eq?: number | null,
  range?: Array< number | null > | null,
};

export type SearchableBooleanFilterInput = {
  eq?: boolean | null,
  ne?: boolean | null,
};

export type SearchableShowBoothItemSortInput = {
  field?: SearchableShowBoothItemSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableShowBoothItemSortableFields {
  id = "id",
  name = "name",
  title = "title",
  readingName = "readingName",
  description = "description",
  keyword = "keyword",
  movie = "movie",
  brand = "brand",
  price = "price",
  boatType = "boatType",
  height = "height",
  capacity = "capacity",
  view360 = "view360",
  section = "section",
  productUrl = "productUrl",
  mapPriority = "mapPriority",
  badge = "badge",
  boothID = "boothID",
  showID = "showID",
  owner = "owner",
  version = "version",
  priority = "priority",
  mapIndex = "mapIndex",
  boothIndex = "boothIndex",
  boothOrder = "boothOrder",
  mapOrder = "mapOrder",
  isExhibition = "isExhibition",
}


export enum SearchableSortDirection {
  asc = "asc",
  desc = "desc",
}


export type SearchableShowBoothItemConnection = {
  __typename: "SearchableShowBoothItemConnection",
  items:  Array<ShowBoothItem | null >,
  nextToken?: string | null,
  total?: number | null,
};

export type ModelBoothUserInfoFilterInput = {
  id?: ModelIDInput | null,
  chatUrl?: ModelStringInput | null,
  chatStatus?: ModelStatusInput | null,
  contactTel?: ModelStringInput | null,
  contactTelInfo?: ModelStringInput | null,
  contactEmail?: ModelStringInput | null,
  contactAddress?: ModelStringInput | null,
  web?: ModelStringInput | null,
  facebook?: ModelStringInput | null,
  boothID?: ModelIDInput | null,
  owner?: ModelStringInput | null,
  version?: ModelIntInput | null,
  and?: Array< ModelBoothUserInfoFilterInput | null > | null,
  or?: Array< ModelBoothUserInfoFilterInput | null > | null,
  not?: ModelBoothUserInfoFilterInput | null,
};

export type ModelBoothUserInfoConnection = {
  __typename: "ModelBoothUserInfoConnection",
  items:  Array<BoothUserInfo | null >,
  nextToken?: string | null,
};

export type ModelAlbumFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  version?: ModelIntInput | null,
  and?: Array< ModelAlbumFilterInput | null > | null,
  or?: Array< ModelAlbumFilterInput | null > | null,
  not?: ModelAlbumFilterInput | null,
};

export type ModelAlbumConnection = {
  __typename: "ModelAlbumConnection",
  items:  Array<Album | null >,
  nextToken?: string | null,
};

export type ModelBoothBoatTypeFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  priority?: ModelIntInput | null,
  owner?: ModelStringInput | null,
  version?: ModelIntInput | null,
  and?: Array< ModelBoothBoatTypeFilterInput | null > | null,
  or?: Array< ModelBoothBoatTypeFilterInput | null > | null,
  not?: ModelBoothBoatTypeFilterInput | null,
};

export type ModelBoothBoatTypeConnection = {
  __typename: "ModelBoothBoatTypeConnection",
  items:  Array<BoothBoatType | null >,
  nextToken?: string | null,
};

export type ModelBoothBoatBrandFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  priority?: ModelIntInput | null,
  owner?: ModelStringInput | null,
  version?: ModelIntInput | null,
  and?: Array< ModelBoothBoatBrandFilterInput | null > | null,
  or?: Array< ModelBoothBoatBrandFilterInput | null > | null,
  not?: ModelBoothBoatBrandFilterInput | null,
};

export type ModelBoothBoatBrandConnection = {
  __typename: "ModelBoothBoatBrandConnection",
  items:  Array<BoothBoatBrand | null >,
  nextToken?: string | null,
};

export type ModelAlbumPhotFilterInput = {
  id?: ModelIDInput | null,
  albumID?: ModelIDInput | null,
  photID?: ModelIDInput | null,
  albumOrder?: ModelIntInput | null,
  owner?: ModelStringInput | null,
  version?: ModelIntInput | null,
  and?: Array< ModelAlbumPhotFilterInput | null > | null,
  or?: Array< ModelAlbumPhotFilterInput | null > | null,
  not?: ModelAlbumPhotFilterInput | null,
};

export type ModelImageFilterInput = {
  id?: ModelIDInput | null,
  alternate?: ModelStringInput | null,
  url?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  version?: ModelIntInput | null,
  and?: Array< ModelImageFilterInput | null > | null,
  or?: Array< ModelImageFilterInput | null > | null,
  not?: ModelImageFilterInput | null,
};

export type ModelImageConnection = {
  __typename: "ModelImageConnection",
  items:  Array<Image | null >,
  nextToken?: string | null,
};

export type ModelShowAudienceFilterInput = {
  id?: ModelIDInput | null,
  showID?: ModelIDInput | null,
  userID?: ModelIDInput | null,
  owner?: ModelStringInput | null,
  version?: ModelIntInput | null,
  and?: Array< ModelShowAudienceFilterInput | null > | null,
  or?: Array< ModelShowAudienceFilterInput | null > | null,
  not?: ModelShowAudienceFilterInput | null,
};

export type ModelShowAudienceConnection = {
  __typename: "ModelShowAudienceConnection",
  items:  Array<ShowAudience | null >,
  nextToken?: string | null,
};

export type ModelUserFilterInput = {
  id?: ModelIDInput | null,
  identity_id?: ModelIDInput | null,
  email?: ModelStringInput | null,
  group?: ModelStringInput | null,
  version?: ModelIntInput | null,
  and?: Array< ModelUserFilterInput | null > | null,
  or?: Array< ModelUserFilterInput | null > | null,
  not?: ModelUserFilterInput | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelUserConnection = {
  __typename: "ModelUserConnection",
  items:  Array<User | null >,
  nextToken?: string | null,
};

export type ModelTicketFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelTicketStatusInput | null,
  group?: ModelStringInput | null,
  version?: ModelIntInput | null,
  and?: Array< ModelTicketFilterInput | null > | null,
  or?: Array< ModelTicketFilterInput | null > | null,
  not?: ModelTicketFilterInput | null,
};

export type CreateShowMutationVariables = {
  input: CreateShowInput,
  condition?: ModelShowConditionInput | null,
};

export type CreateShowMutation = {
  createShow?:  {
    __typename: "Show",
    id: string,
    name: string,
    version: number,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateShowMutationVariables = {
  input: UpdateShowInput,
  condition?: ModelShowConditionInput | null,
};

export type UpdateShowMutation = {
  updateShow?:  {
    __typename: "Show",
    id: string,
    name: string,
    version: number,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteShowMutationVariables = {
  input: DeleteShowInput,
  condition?: ModelShowConditionInput | null,
};

export type DeleteShowMutation = {
  deleteShow?:  {
    __typename: "Show",
    id: string,
    name: string,
    version: number,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateShowSettingMutationVariables = {
  input: CreateShowSettingInput,
  condition?: ModelShowSettingConditionInput | null,
};

export type CreateShowSettingMutation = {
  createShowSetting?:  {
    __typename: "ShowSetting",
    id: string,
    name?: string | null,
    title?: string | null,
    description?: string | null,
    slug?: string | null,
    startDateTime?: string | null,
    endDateTime?: string | null,
    status: Status,
    owner?: string | null,
    showID: string,
    version: number,
    createdAt: string,
    updatedAt: string,
    ogpImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type UpdateShowSettingMutationVariables = {
  input: UpdateShowSettingInput,
  condition?: ModelShowSettingConditionInput | null,
};

export type UpdateShowSettingMutation = {
  updateShowSetting?:  {
    __typename: "ShowSetting",
    id: string,
    name?: string | null,
    title?: string | null,
    description?: string | null,
    slug?: string | null,
    startDateTime?: string | null,
    endDateTime?: string | null,
    status: Status,
    owner?: string | null,
    showID: string,
    version: number,
    createdAt: string,
    updatedAt: string,
    ogpImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type DeleteShowSettingMutationVariables = {
  input: DeleteShowSettingInput,
  condition?: ModelShowSettingConditionInput | null,
};

export type DeleteShowSettingMutation = {
  deleteShowSetting?:  {
    __typename: "ShowSetting",
    id: string,
    name?: string | null,
    title?: string | null,
    description?: string | null,
    slug?: string | null,
    startDateTime?: string | null,
    endDateTime?: string | null,
    status: Status,
    owner?: string | null,
    showID: string,
    version: number,
    createdAt: string,
    updatedAt: string,
    ogpImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type CreateShowMainMutationVariables = {
  input: CreateShowMainInput,
  condition?: ModelShowMainConditionInput | null,
};

export type CreateShowMainMutation = {
  createShowMain?:  {
    __typename: "ShowMain",
    id: string,
    title: string,
    mapDiscription?: string | null,
    logoDiscription?: string | null,
    discription?: string | null,
    section?: string | null,
    status: Status,
    showID: string,
    search?: boolean | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type UpdateShowMainMutationVariables = {
  input: UpdateShowMainInput,
  condition?: ModelShowMainConditionInput | null,
};

export type UpdateShowMainMutation = {
  updateShowMain?:  {
    __typename: "ShowMain",
    id: string,
    title: string,
    mapDiscription?: string | null,
    logoDiscription?: string | null,
    discription?: string | null,
    section?: string | null,
    status: Status,
    showID: string,
    search?: boolean | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type DeleteShowMainMutationVariables = {
  input: DeleteShowMainInput,
  condition?: ModelShowMainConditionInput | null,
};

export type DeleteShowMainMutation = {
  deleteShowMain?:  {
    __typename: "ShowMain",
    id: string,
    title: string,
    mapDiscription?: string | null,
    logoDiscription?: string | null,
    discription?: string | null,
    section?: string | null,
    status: Status,
    showID: string,
    search?: boolean | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type CreateTeaserMutationVariables = {
  input: CreateTeaserInput,
  condition?: ModelTeaserConditionInput | null,
};

export type CreateTeaserMutation = {
  createTeaser?:  {
    __typename: "Teaser",
    id: string,
    title: string,
    discription?: string | null,
    countDown?: boolean | null,
    section?: string | null,
    status: Status,
    showID: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type UpdateTeaserMutationVariables = {
  input: UpdateTeaserInput,
  condition?: ModelTeaserConditionInput | null,
};

export type UpdateTeaserMutation = {
  updateTeaser?:  {
    __typename: "Teaser",
    id: string,
    title: string,
    discription?: string | null,
    countDown?: boolean | null,
    section?: string | null,
    status: Status,
    showID: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type DeleteTeaserMutationVariables = {
  input: DeleteTeaserInput,
  condition?: ModelTeaserConditionInput | null,
};

export type DeleteTeaserMutation = {
  deleteTeaser?:  {
    __typename: "Teaser",
    id: string,
    title: string,
    discription?: string | null,
    countDown?: boolean | null,
    section?: string | null,
    status: Status,
    showID: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type CreatePageMutationVariables = {
  input: CreatePageInput,
  condition?: ModelPageConditionInput | null,
};

export type CreatePageMutation = {
  createPage?:  {
    __typename: "Page",
    id: string,
    root: string,
    slug: string,
    title: string,
    discription?: string | null,
    contents?: string | null,
    status: Status,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type UpdatePageMutationVariables = {
  input: UpdatePageInput,
  condition?: ModelPageConditionInput | null,
};

export type UpdatePageMutation = {
  updatePage?:  {
    __typename: "Page",
    id: string,
    root: string,
    slug: string,
    title: string,
    discription?: string | null,
    contents?: string | null,
    status: Status,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type DeletePageMutationVariables = {
  input: DeletePageInput,
  condition?: ModelPageConditionInput | null,
};

export type DeletePageMutation = {
  deletePage?:  {
    __typename: "Page",
    id: string,
    root: string,
    slug: string,
    title: string,
    discription?: string | null,
    contents?: string | null,
    status: Status,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type CreateTopPageMutationVariables = {
  input: CreateTopPageInput,
  condition?: ModelTopPageConditionInput | null,
};

export type CreateTopPageMutation = {
  createTopPage?:  {
    __typename: "TopPage",
    id: string,
    title: string,
    discription?: string | null,
    contents?: string | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type UpdateTopPageMutationVariables = {
  input: UpdateTopPageInput,
  condition?: ModelTopPageConditionInput | null,
};

export type UpdateTopPageMutation = {
  updateTopPage?:  {
    __typename: "TopPage",
    id: string,
    title: string,
    discription?: string | null,
    contents?: string | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type DeleteTopPageMutationVariables = {
  input: DeleteTopPageInput,
  condition?: ModelTopPageConditionInput | null,
};

export type DeleteTopPageMutation = {
  deleteTopPage?:  {
    __typename: "TopPage",
    id: string,
    title: string,
    discription?: string | null,
    contents?: string | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type CreateShowBoothMutationVariables = {
  input: CreateShowBoothInput,
  condition?: ModelShowBoothConditionInput | null,
};

export type CreateShowBoothMutation = {
  createShowBooth?:  {
    __typename: "ShowBooth",
    id: string,
    name: string,
    title: string,
    discription?: string | null,
    section?: string | null,
    priority?: number | null,
    status: Status,
    showID: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    brandLogos?:  {
      __typename: "Album",
      id: string,
      name?: string | null,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      phots?:  {
        __typename: "ModelAlbumPhotConnection",
        items:  Array< {
          __typename: "AlbumPhot",
          id: string,
          albumID: string,
          photID: string,
          albumOrder?: number | null,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          album?:  {
            __typename: "Album",
            id: string,
            name?: string | null,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
          phot?:  {
            __typename: "Image",
            id: string,
            alternate: string,
            url: string,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type UpdateShowBoothMutationVariables = {
  input: UpdateShowBoothInput,
  condition?: ModelShowBoothConditionInput | null,
};

export type UpdateShowBoothMutation = {
  updateShowBooth?:  {
    __typename: "ShowBooth",
    id: string,
    name: string,
    title: string,
    discription?: string | null,
    section?: string | null,
    priority?: number | null,
    status: Status,
    showID: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    brandLogos?:  {
      __typename: "Album",
      id: string,
      name?: string | null,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      phots?:  {
        __typename: "ModelAlbumPhotConnection",
        items:  Array< {
          __typename: "AlbumPhot",
          id: string,
          albumID: string,
          photID: string,
          albumOrder?: number | null,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          album?:  {
            __typename: "Album",
            id: string,
            name?: string | null,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
          phot?:  {
            __typename: "Image",
            id: string,
            alternate: string,
            url: string,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type DeleteShowBoothMutationVariables = {
  input: DeleteShowBoothInput,
  condition?: ModelShowBoothConditionInput | null,
};

export type DeleteShowBoothMutation = {
  deleteShowBooth?:  {
    __typename: "ShowBooth",
    id: string,
    name: string,
    title: string,
    discription?: string | null,
    section?: string | null,
    priority?: number | null,
    status: Status,
    showID: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    brandLogos?:  {
      __typename: "Album",
      id: string,
      name?: string | null,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      phots?:  {
        __typename: "ModelAlbumPhotConnection",
        items:  Array< {
          __typename: "AlbumPhot",
          id: string,
          albumID: string,
          photID: string,
          albumOrder?: number | null,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          album?:  {
            __typename: "Album",
            id: string,
            name?: string | null,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
          phot?:  {
            __typename: "Image",
            id: string,
            alternate: string,
            url: string,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type CreateShowBoothItemMutationVariables = {
  input: CreateShowBoothItemInput,
  condition?: ModelShowBoothItemConditionInput | null,
};

export type CreateShowBoothItemMutation = {
  createShowBoothItem?:  {
    __typename: "ShowBoothItem",
    id: string,
    name?: string | null,
    title?: string | null,
    readingName?: string | null,
    description?: string | null,
    keyword?: string | null,
    movie?: string | null,
    brand?: string | null,
    price?: number | null,
    boatType?: string | null,
    height?: number | null,
    capacity?: number | null,
    view360?: string | null,
    section?: string | null,
    productUrl?: string | null,
    mapPriority?: number | null,
    badge?: string | null,
    status: Status,
    boothID: string,
    showID: string,
    owner?: string | null,
    version: number,
    priority?: number | null,
    mapIndex?: number | null,
    boothIndex?: number | null,
    boothOrder?: number | null,
    mapOrder?: number | null,
    isExhibition?: boolean | null,
    createdAt: string,
    updatedAt: string,
    photoGallery?:  {
      __typename: "Album",
      id: string,
      name?: string | null,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      phots?:  {
        __typename: "ModelAlbumPhotConnection",
        items:  Array< {
          __typename: "AlbumPhot",
          id: string,
          albumID: string,
          photID: string,
          albumOrder?: number | null,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          album?:  {
            __typename: "Album",
            id: string,
            name?: string | null,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
          phot?:  {
            __typename: "Image",
            id: string,
            alternate: string,
            url: string,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    mainImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
    logo?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
    mapIcon?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
    thumbnail?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type UpdateShowBoothItemMutationVariables = {
  input: UpdateShowBoothItemInput,
  condition?: ModelShowBoothItemConditionInput | null,
};

export type UpdateShowBoothItemMutation = {
  updateShowBoothItem?:  {
    __typename: "ShowBoothItem",
    id: string,
    name?: string | null,
    title?: string | null,
    readingName?: string | null,
    description?: string | null,
    keyword?: string | null,
    movie?: string | null,
    brand?: string | null,
    price?: number | null,
    boatType?: string | null,
    height?: number | null,
    capacity?: number | null,
    view360?: string | null,
    section?: string | null,
    productUrl?: string | null,
    mapPriority?: number | null,
    badge?: string | null,
    status: Status,
    boothID: string,
    showID: string,
    owner?: string | null,
    version: number,
    priority?: number | null,
    mapIndex?: number | null,
    boothIndex?: number | null,
    boothOrder?: number | null,
    mapOrder?: number | null,
    isExhibition?: boolean | null,
    createdAt: string,
    updatedAt: string,
    photoGallery?:  {
      __typename: "Album",
      id: string,
      name?: string | null,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      phots?:  {
        __typename: "ModelAlbumPhotConnection",
        items:  Array< {
          __typename: "AlbumPhot",
          id: string,
          albumID: string,
          photID: string,
          albumOrder?: number | null,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          album?:  {
            __typename: "Album",
            id: string,
            name?: string | null,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
          phot?:  {
            __typename: "Image",
            id: string,
            alternate: string,
            url: string,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    mainImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
    logo?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
    mapIcon?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
    thumbnail?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type DeleteShowBoothItemMutationVariables = {
  input: DeleteShowBoothItemInput,
  condition?: ModelShowBoothItemConditionInput | null,
};

export type DeleteShowBoothItemMutation = {
  deleteShowBoothItem?:  {
    __typename: "ShowBoothItem",
    id: string,
    name?: string | null,
    title?: string | null,
    readingName?: string | null,
    description?: string | null,
    keyword?: string | null,
    movie?: string | null,
    brand?: string | null,
    price?: number | null,
    boatType?: string | null,
    height?: number | null,
    capacity?: number | null,
    view360?: string | null,
    section?: string | null,
    productUrl?: string | null,
    mapPriority?: number | null,
    badge?: string | null,
    status: Status,
    boothID: string,
    showID: string,
    owner?: string | null,
    version: number,
    priority?: number | null,
    mapIndex?: number | null,
    boothIndex?: number | null,
    boothOrder?: number | null,
    mapOrder?: number | null,
    isExhibition?: boolean | null,
    createdAt: string,
    updatedAt: string,
    photoGallery?:  {
      __typename: "Album",
      id: string,
      name?: string | null,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      phots?:  {
        __typename: "ModelAlbumPhotConnection",
        items:  Array< {
          __typename: "AlbumPhot",
          id: string,
          albumID: string,
          photID: string,
          albumOrder?: number | null,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          album?:  {
            __typename: "Album",
            id: string,
            name?: string | null,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
          phot?:  {
            __typename: "Image",
            id: string,
            alternate: string,
            url: string,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    mainImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
    logo?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
    mapIcon?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
    thumbnail?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type CreateBoothUserInfoMutationVariables = {
  input: CreateBoothUserInfoInput,
  condition?: ModelBoothUserInfoConditionInput | null,
};

export type CreateBoothUserInfoMutation = {
  createBoothUserInfo?:  {
    __typename: "BoothUserInfo",
    id: string,
    chatUrl?: string | null,
    chatStatus: Status,
    contactTel?: string | null,
    contactTelInfo?: string | null,
    contactEmail?: string | null,
    contactAddress?: string | null,
    web?: string | null,
    facebook?: string | null,
    boothID: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateBoothUserInfoMutationVariables = {
  input: UpdateBoothUserInfoInput,
  condition?: ModelBoothUserInfoConditionInput | null,
};

export type UpdateBoothUserInfoMutation = {
  updateBoothUserInfo?:  {
    __typename: "BoothUserInfo",
    id: string,
    chatUrl?: string | null,
    chatStatus: Status,
    contactTel?: string | null,
    contactTelInfo?: string | null,
    contactEmail?: string | null,
    contactAddress?: string | null,
    web?: string | null,
    facebook?: string | null,
    boothID: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteBoothUserInfoMutationVariables = {
  input: DeleteBoothUserInfoInput,
  condition?: ModelBoothUserInfoConditionInput | null,
};

export type DeleteBoothUserInfoMutation = {
  deleteBoothUserInfo?:  {
    __typename: "BoothUserInfo",
    id: string,
    chatUrl?: string | null,
    chatStatus: Status,
    contactTel?: string | null,
    contactTelInfo?: string | null,
    contactEmail?: string | null,
    contactAddress?: string | null,
    web?: string | null,
    facebook?: string | null,
    boothID: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateAlbumMutationVariables = {
  input: CreateAlbumInput,
  condition?: ModelAlbumConditionInput | null,
};

export type CreateAlbumMutation = {
  createAlbum?:  {
    __typename: "Album",
    id: string,
    name?: string | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    phots?:  {
      __typename: "ModelAlbumPhotConnection",
      items:  Array< {
        __typename: "AlbumPhot",
        id: string,
        albumID: string,
        photID: string,
        albumOrder?: number | null,
        owner?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
        album?:  {
          __typename: "Album",
          id: string,
          name?: string | null,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          phots?:  {
            __typename: "ModelAlbumPhotConnection",
            nextToken?: string | null,
          } | null,
        } | null,
        phot?:  {
          __typename: "Image",
          id: string,
          alternate: string,
          storage:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          url: string,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type UpdateAlbumMutationVariables = {
  input: UpdateAlbumInput,
  condition?: ModelAlbumConditionInput | null,
};

export type UpdateAlbumMutation = {
  updateAlbum?:  {
    __typename: "Album",
    id: string,
    name?: string | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    phots?:  {
      __typename: "ModelAlbumPhotConnection",
      items:  Array< {
        __typename: "AlbumPhot",
        id: string,
        albumID: string,
        photID: string,
        albumOrder?: number | null,
        owner?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
        album?:  {
          __typename: "Album",
          id: string,
          name?: string | null,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          phots?:  {
            __typename: "ModelAlbumPhotConnection",
            nextToken?: string | null,
          } | null,
        } | null,
        phot?:  {
          __typename: "Image",
          id: string,
          alternate: string,
          storage:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          url: string,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type DeleteAlbumMutationVariables = {
  input: DeleteAlbumInput,
  condition?: ModelAlbumConditionInput | null,
};

export type DeleteAlbumMutation = {
  deleteAlbum?:  {
    __typename: "Album",
    id: string,
    name?: string | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    phots?:  {
      __typename: "ModelAlbumPhotConnection",
      items:  Array< {
        __typename: "AlbumPhot",
        id: string,
        albumID: string,
        photID: string,
        albumOrder?: number | null,
        owner?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
        album?:  {
          __typename: "Album",
          id: string,
          name?: string | null,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          phots?:  {
            __typename: "ModelAlbumPhotConnection",
            nextToken?: string | null,
          } | null,
        } | null,
        phot?:  {
          __typename: "Image",
          id: string,
          alternate: string,
          storage:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          url: string,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type CreateBoothBoatTypeMutationVariables = {
  input: CreateBoothBoatTypeInput,
  condition?: ModelBoothBoatTypeConditionInput | null,
};

export type CreateBoothBoatTypeMutation = {
  createBoothBoatType?:  {
    __typename: "BoothBoatType",
    id: string,
    name: string,
    priority?: number | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateBoothBoatTypeMutationVariables = {
  input: UpdateBoothBoatTypeInput,
  condition?: ModelBoothBoatTypeConditionInput | null,
};

export type UpdateBoothBoatTypeMutation = {
  updateBoothBoatType?:  {
    __typename: "BoothBoatType",
    id: string,
    name: string,
    priority?: number | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteBoothBoatTypeMutationVariables = {
  input: DeleteBoothBoatTypeInput,
  condition?: ModelBoothBoatTypeConditionInput | null,
};

export type DeleteBoothBoatTypeMutation = {
  deleteBoothBoatType?:  {
    __typename: "BoothBoatType",
    id: string,
    name: string,
    priority?: number | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateBoothBoatBrandMutationVariables = {
  input: CreateBoothBoatBrandInput,
  condition?: ModelBoothBoatBrandConditionInput | null,
};

export type CreateBoothBoatBrandMutation = {
  createBoothBoatBrand?:  {
    __typename: "BoothBoatBrand",
    id: string,
    name: string,
    priority?: number | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateBoothBoatBrandMutationVariables = {
  input: UpdateBoothBoatBrandInput,
  condition?: ModelBoothBoatBrandConditionInput | null,
};

export type UpdateBoothBoatBrandMutation = {
  updateBoothBoatBrand?:  {
    __typename: "BoothBoatBrand",
    id: string,
    name: string,
    priority?: number | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteBoothBoatBrandMutationVariables = {
  input: DeleteBoothBoatBrandInput,
  condition?: ModelBoothBoatBrandConditionInput | null,
};

export type DeleteBoothBoatBrandMutation = {
  deleteBoothBoatBrand?:  {
    __typename: "BoothBoatBrand",
    id: string,
    name: string,
    priority?: number | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateAlbumPhotMutationVariables = {
  input: CreateAlbumPhotInput,
  condition?: ModelAlbumPhotConditionInput | null,
};

export type CreateAlbumPhotMutation = {
  createAlbumPhot?:  {
    __typename: "AlbumPhot",
    id: string,
    albumID: string,
    photID: string,
    albumOrder?: number | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    album?:  {
      __typename: "Album",
      id: string,
      name?: string | null,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      phots?:  {
        __typename: "ModelAlbumPhotConnection",
        items:  Array< {
          __typename: "AlbumPhot",
          id: string,
          albumID: string,
          photID: string,
          albumOrder?: number | null,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          album?:  {
            __typename: "Album",
            id: string,
            name?: string | null,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
          phot?:  {
            __typename: "Image",
            id: string,
            alternate: string,
            url: string,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    phot?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type UpdateAlbumPhotMutationVariables = {
  input: UpdateAlbumPhotInput,
  condition?: ModelAlbumPhotConditionInput | null,
};

export type UpdateAlbumPhotMutation = {
  updateAlbumPhot?:  {
    __typename: "AlbumPhot",
    id: string,
    albumID: string,
    photID: string,
    albumOrder?: number | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    album?:  {
      __typename: "Album",
      id: string,
      name?: string | null,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      phots?:  {
        __typename: "ModelAlbumPhotConnection",
        items:  Array< {
          __typename: "AlbumPhot",
          id: string,
          albumID: string,
          photID: string,
          albumOrder?: number | null,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          album?:  {
            __typename: "Album",
            id: string,
            name?: string | null,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
          phot?:  {
            __typename: "Image",
            id: string,
            alternate: string,
            url: string,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    phot?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type DeleteAlbumPhotMutationVariables = {
  input: DeleteAlbumPhotInput,
  condition?: ModelAlbumPhotConditionInput | null,
};

export type DeleteAlbumPhotMutation = {
  deleteAlbumPhot?:  {
    __typename: "AlbumPhot",
    id: string,
    albumID: string,
    photID: string,
    albumOrder?: number | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    album?:  {
      __typename: "Album",
      id: string,
      name?: string | null,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      phots?:  {
        __typename: "ModelAlbumPhotConnection",
        items:  Array< {
          __typename: "AlbumPhot",
          id: string,
          albumID: string,
          photID: string,
          albumOrder?: number | null,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          album?:  {
            __typename: "Album",
            id: string,
            name?: string | null,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
          phot?:  {
            __typename: "Image",
            id: string,
            alternate: string,
            url: string,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    phot?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type CreateImageMutationVariables = {
  input: CreateImageInput,
  condition?: ModelImageConditionInput | null,
};

export type CreateImageMutation = {
  createImage?:  {
    __typename: "Image",
    id: string,
    alternate: string,
    storage:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    },
    url: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateImageMutationVariables = {
  input: UpdateImageInput,
  condition?: ModelImageConditionInput | null,
};

export type UpdateImageMutation = {
  updateImage?:  {
    __typename: "Image",
    id: string,
    alternate: string,
    storage:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    },
    url: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteImageMutationVariables = {
  input: DeleteImageInput,
  condition?: ModelImageConditionInput | null,
};

export type DeleteImageMutation = {
  deleteImage?:  {
    __typename: "Image",
    id: string,
    alternate: string,
    storage:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    },
    url: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateShowAudienceMutationVariables = {
  input: CreateShowAudienceInput,
  condition?: ModelShowAudienceConditionInput | null,
};

export type CreateShowAudienceMutation = {
  createShowAudience?:  {
    __typename: "ShowAudience",
    id: string,
    showID: string,
    userID: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    show?:  {
      __typename: "Show",
      id: string,
      name: string,
      version: number,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    users?:  {
      __typename: "User",
      id?: string | null,
      identity_id: string,
      email: string,
      group?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      tickets?:  {
        __typename: "ModelTicketConnection",
        items:  Array< {
          __typename: "Ticket",
          id?: string | null,
          status?: TicketStatus | null,
          group?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          activatedUser?:  {
            __typename: "User",
            id?: string | null,
            identity_id: string,
            email: string,
            group?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateShowAudienceMutationVariables = {
  input: UpdateShowAudienceInput,
  condition?: ModelShowAudienceConditionInput | null,
};

export type UpdateShowAudienceMutation = {
  updateShowAudience?:  {
    __typename: "ShowAudience",
    id: string,
    showID: string,
    userID: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    show?:  {
      __typename: "Show",
      id: string,
      name: string,
      version: number,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    users?:  {
      __typename: "User",
      id?: string | null,
      identity_id: string,
      email: string,
      group?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      tickets?:  {
        __typename: "ModelTicketConnection",
        items:  Array< {
          __typename: "Ticket",
          id?: string | null,
          status?: TicketStatus | null,
          group?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          activatedUser?:  {
            __typename: "User",
            id?: string | null,
            identity_id: string,
            email: string,
            group?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteShowAudienceMutationVariables = {
  input: DeleteShowAudienceInput,
  condition?: ModelShowAudienceConditionInput | null,
};

export type DeleteShowAudienceMutation = {
  deleteShowAudience?:  {
    __typename: "ShowAudience",
    id: string,
    showID: string,
    userID: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    show?:  {
      __typename: "Show",
      id: string,
      name: string,
      version: number,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    users?:  {
      __typename: "User",
      id?: string | null,
      identity_id: string,
      email: string,
      group?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      tickets?:  {
        __typename: "ModelTicketConnection",
        items:  Array< {
          __typename: "Ticket",
          id?: string | null,
          status?: TicketStatus | null,
          group?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          activatedUser?:  {
            __typename: "User",
            id?: string | null,
            identity_id: string,
            email: string,
            group?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type CreateUserMutationVariables = {
  input: CreateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type CreateUserMutation = {
  createUser?:  {
    __typename: "User",
    id?: string | null,
    identity_id: string,
    email: string,
    group?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    tickets?:  {
      __typename: "ModelTicketConnection",
      items:  Array< {
        __typename: "Ticket",
        id?: string | null,
        status?: TicketStatus | null,
        group?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
        activatedUser?:  {
          __typename: "User",
          id?: string | null,
          identity_id: string,
          email: string,
          group?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          tickets?:  {
            __typename: "ModelTicketConnection",
            nextToken?: string | null,
          } | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type UpdateUserMutationVariables = {
  input: UpdateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type UpdateUserMutation = {
  updateUser?:  {
    __typename: "User",
    id?: string | null,
    identity_id: string,
    email: string,
    group?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    tickets?:  {
      __typename: "ModelTicketConnection",
      items:  Array< {
        __typename: "Ticket",
        id?: string | null,
        status?: TicketStatus | null,
        group?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
        activatedUser?:  {
          __typename: "User",
          id?: string | null,
          identity_id: string,
          email: string,
          group?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          tickets?:  {
            __typename: "ModelTicketConnection",
            nextToken?: string | null,
          } | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type DeleteUserMutationVariables = {
  input: DeleteUserInput,
  condition?: ModelUserConditionInput | null,
};

export type DeleteUserMutation = {
  deleteUser?:  {
    __typename: "User",
    id?: string | null,
    identity_id: string,
    email: string,
    group?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    tickets?:  {
      __typename: "ModelTicketConnection",
      items:  Array< {
        __typename: "Ticket",
        id?: string | null,
        status?: TicketStatus | null,
        group?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
        activatedUser?:  {
          __typename: "User",
          id?: string | null,
          identity_id: string,
          email: string,
          group?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          tickets?:  {
            __typename: "ModelTicketConnection",
            nextToken?: string | null,
          } | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type CreateTicketMutationVariables = {
  input: CreateTicketInput,
  condition?: ModelTicketConditionInput | null,
};

export type CreateTicketMutation = {
  createTicket?:  {
    __typename: "Ticket",
    id?: string | null,
    status?: TicketStatus | null,
    group?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    activatedUser?:  {
      __typename: "User",
      id?: string | null,
      identity_id: string,
      email: string,
      group?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      tickets?:  {
        __typename: "ModelTicketConnection",
        items:  Array< {
          __typename: "Ticket",
          id?: string | null,
          status?: TicketStatus | null,
          group?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          activatedUser?:  {
            __typename: "User",
            id?: string | null,
            identity_id: string,
            email: string,
            group?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateTicketMutationVariables = {
  input: UpdateTicketInput,
  condition?: ModelTicketConditionInput | null,
};

export type UpdateTicketMutation = {
  updateTicket?:  {
    __typename: "Ticket",
    id?: string | null,
    status?: TicketStatus | null,
    group?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    activatedUser?:  {
      __typename: "User",
      id?: string | null,
      identity_id: string,
      email: string,
      group?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      tickets?:  {
        __typename: "ModelTicketConnection",
        items:  Array< {
          __typename: "Ticket",
          id?: string | null,
          status?: TicketStatus | null,
          group?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          activatedUser?:  {
            __typename: "User",
            id?: string | null,
            identity_id: string,
            email: string,
            group?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteTicketMutationVariables = {
  input: DeleteTicketInput,
  condition?: ModelTicketConditionInput | null,
};

export type DeleteTicketMutation = {
  deleteTicket?:  {
    __typename: "Ticket",
    id?: string | null,
    status?: TicketStatus | null,
    group?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    activatedUser?:  {
      __typename: "User",
      id?: string | null,
      identity_id: string,
      email: string,
      group?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      tickets?:  {
        __typename: "ModelTicketConnection",
        items:  Array< {
          __typename: "Ticket",
          id?: string | null,
          status?: TicketStatus | null,
          group?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          activatedUser?:  {
            __typename: "User",
            id?: string | null,
            identity_id: string,
            email: string,
            group?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type GetShowQueryVariables = {
  id: string,
};

export type GetShowQuery = {
  getShow?:  {
    __typename: "Show",
    id: string,
    name: string,
    version: number,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListShowsQueryVariables = {
  filter?: ModelShowFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListShowsQuery = {
  listShows?:  {
    __typename: "ModelShowConnection",
    items:  Array< {
      __typename: "Show",
      id: string,
      name: string,
      version: number,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetShowSettingQueryVariables = {
  id: string,
};

export type GetShowSettingQuery = {
  getShowSetting?:  {
    __typename: "ShowSetting",
    id: string,
    name?: string | null,
    title?: string | null,
    description?: string | null,
    slug?: string | null,
    startDateTime?: string | null,
    endDateTime?: string | null,
    status: Status,
    owner?: string | null,
    showID: string,
    version: number,
    createdAt: string,
    updatedAt: string,
    ogpImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type ListShowSettingsQueryVariables = {
  filter?: ModelShowSettingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListShowSettingsQuery = {
  listShowSettings?:  {
    __typename: "ModelShowSettingConnection",
    items:  Array< {
      __typename: "ShowSetting",
      id: string,
      name?: string | null,
      title?: string | null,
      description?: string | null,
      slug?: string | null,
      startDateTime?: string | null,
      endDateTime?: string | null,
      status: Status,
      owner?: string | null,
      showID: string,
      version: number,
      createdAt: string,
      updatedAt: string,
      ogpImage?:  {
        __typename: "Image",
        id: string,
        alternate: string,
        storage:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        url: string,
        owner?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetShowMainQueryVariables = {
  id: string,
};

export type GetShowMainQuery = {
  getShowMain?:  {
    __typename: "ShowMain",
    id: string,
    title: string,
    mapDiscription?: string | null,
    logoDiscription?: string | null,
    discription?: string | null,
    section?: string | null,
    status: Status,
    showID: string,
    search?: boolean | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type ListShowMainsQueryVariables = {
  filter?: ModelShowMainFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListShowMainsQuery = {
  listShowMains?:  {
    __typename: "ModelShowMainConnection",
    items:  Array< {
      __typename: "ShowMain",
      id: string,
      title: string,
      mapDiscription?: string | null,
      logoDiscription?: string | null,
      discription?: string | null,
      section?: string | null,
      status: Status,
      showID: string,
      search?: boolean | null,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      backgroundImage?:  {
        __typename: "Image",
        id: string,
        alternate: string,
        storage:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        url: string,
        owner?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetTeaserQueryVariables = {
  id: string,
};

export type GetTeaserQuery = {
  getTeaser?:  {
    __typename: "Teaser",
    id: string,
    title: string,
    discription?: string | null,
    countDown?: boolean | null,
    section?: string | null,
    status: Status,
    showID: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type ListTeasersQueryVariables = {
  filter?: ModelTeaserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTeasersQuery = {
  listTeasers?:  {
    __typename: "ModelTeaserConnection",
    items:  Array< {
      __typename: "Teaser",
      id: string,
      title: string,
      discription?: string | null,
      countDown?: boolean | null,
      section?: string | null,
      status: Status,
      showID: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      backgroundImage?:  {
        __typename: "Image",
        id: string,
        alternate: string,
        storage:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        url: string,
        owner?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPageQueryVariables = {
  id: string,
};

export type GetPageQuery = {
  getPage?:  {
    __typename: "Page",
    id: string,
    root: string,
    slug: string,
    title: string,
    discription?: string | null,
    contents?: string | null,
    status: Status,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type ListPagesQueryVariables = {
  filter?: ModelPageFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPagesQuery = {
  listPages?:  {
    __typename: "ModelPageConnection",
    items:  Array< {
      __typename: "Page",
      id: string,
      root: string,
      slug: string,
      title: string,
      discription?: string | null,
      contents?: string | null,
      status: Status,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      backgroundImage?:  {
        __typename: "Image",
        id: string,
        alternate: string,
        storage:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        url: string,
        owner?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetTopPageQueryVariables = {
  id: string,
};

export type GetTopPageQuery = {
  getTopPage?:  {
    __typename: "TopPage",
    id: string,
    title: string,
    discription?: string | null,
    contents?: string | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type ListTopPagesQueryVariables = {
  filter?: ModelTopPageFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTopPagesQuery = {
  listTopPages?:  {
    __typename: "ModelTopPageConnection",
    items:  Array< {
      __typename: "TopPage",
      id: string,
      title: string,
      discription?: string | null,
      contents?: string | null,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      backgroundImage?:  {
        __typename: "Image",
        id: string,
        alternate: string,
        storage:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        url: string,
        owner?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetShowBoothQueryVariables = {
  id: string,
};

export type GetShowBoothQuery = {
  getShowBooth?:  {
    __typename: "ShowBooth",
    id: string,
    name: string,
    title: string,
    discription?: string | null,
    section?: string | null,
    priority?: number | null,
    status: Status,
    showID: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    brandLogos?:  {
      __typename: "Album",
      id: string,
      name?: string | null,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      phots?:  {
        __typename: "ModelAlbumPhotConnection",
        items:  Array< {
          __typename: "AlbumPhot",
          id: string,
          albumID: string,
          photID: string,
          albumOrder?: number | null,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          album?:  {
            __typename: "Album",
            id: string,
            name?: string | null,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
          phot?:  {
            __typename: "Image",
            id: string,
            alternate: string,
            url: string,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type ListShowBoothsQueryVariables = {
  filter?: ModelShowBoothFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListShowBoothsQuery = {
  listShowBooths?:  {
    __typename: "ModelShowBoothConnection",
    items:  Array< {
      __typename: "ShowBooth",
      id: string,
      name: string,
      title: string,
      discription?: string | null,
      section?: string | null,
      priority?: number | null,
      status: Status,
      showID: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      brandLogos?:  {
        __typename: "Album",
        id: string,
        name?: string | null,
        owner?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
        phots?:  {
          __typename: "ModelAlbumPhotConnection",
          items:  Array< {
            __typename: "AlbumPhot",
            id: string,
            albumID: string,
            photID: string,
            albumOrder?: number | null,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
      } | null,
      backgroundImage?:  {
        __typename: "Image",
        id: string,
        alternate: string,
        storage:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        url: string,
        owner?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetShowBoothItemQueryVariables = {
  id: string,
};

export type GetShowBoothItemQuery = {
  getShowBoothItem?:  {
    __typename: "ShowBoothItem",
    id: string,
    name?: string | null,
    title?: string | null,
    readingName?: string | null,
    description?: string | null,
    keyword?: string | null,
    movie?: string | null,
    brand?: string | null,
    price?: number | null,
    boatType?: string | null,
    height?: number | null,
    capacity?: number | null,
    view360?: string | null,
    section?: string | null,
    productUrl?: string | null,
    mapPriority?: number | null,
    badge?: string | null,
    status: Status,
    boothID: string,
    showID: string,
    owner?: string | null,
    version: number,
    priority?: number | null,
    mapIndex?: number | null,
    boothIndex?: number | null,
    boothOrder?: number | null,
    mapOrder?: number | null,
    isExhibition?: boolean | null,
    createdAt: string,
    updatedAt: string,
    photoGallery?:  {
      __typename: "Album",
      id: string,
      name?: string | null,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      phots?:  {
        __typename: "ModelAlbumPhotConnection",
        items:  Array< {
          __typename: "AlbumPhot",
          id: string,
          albumID: string,
          photID: string,
          albumOrder?: number | null,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          album?:  {
            __typename: "Album",
            id: string,
            name?: string | null,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
          phot?:  {
            __typename: "Image",
            id: string,
            alternate: string,
            url: string,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    mainImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
    logo?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
    mapIcon?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
    thumbnail?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type ListShowBoothItemsQueryVariables = {
  filter?: ModelShowBoothItemFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListShowBoothItemsQuery = {
  listShowBoothItems?:  {
    __typename: "ModelShowBoothItemConnection",
    items:  Array< {
      __typename: "ShowBoothItem",
      id: string,
      name?: string | null,
      title?: string | null,
      readingName?: string | null,
      description?: string | null,
      keyword?: string | null,
      movie?: string | null,
      brand?: string | null,
      price?: number | null,
      boatType?: string | null,
      height?: number | null,
      capacity?: number | null,
      view360?: string | null,
      section?: string | null,
      productUrl?: string | null,
      mapPriority?: number | null,
      badge?: string | null,
      status: Status,
      boothID: string,
      showID: string,
      owner?: string | null,
      version: number,
      priority?: number | null,
      mapIndex?: number | null,
      boothIndex?: number | null,
      boothOrder?: number | null,
      mapOrder?: number | null,
      isExhibition?: boolean | null,
      createdAt: string,
      updatedAt: string,
      photoGallery?:  {
        __typename: "Album",
        id: string,
        name?: string | null,
        owner?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
        phots?:  {
          __typename: "ModelAlbumPhotConnection",
          items:  Array< {
            __typename: "AlbumPhot",
            id: string,
            albumID: string,
            photID: string,
            albumOrder?: number | null,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
      } | null,
      mainImage?:  {
        __typename: "Image",
        id: string,
        alternate: string,
        storage:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        url: string,
        owner?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
      } | null,
      logo?:  {
        __typename: "Image",
        id: string,
        alternate: string,
        storage:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        url: string,
        owner?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
      } | null,
      mapIcon?:  {
        __typename: "Image",
        id: string,
        alternate: string,
        storage:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        url: string,
        owner?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
      } | null,
      thumbnail?:  {
        __typename: "Image",
        id: string,
        alternate: string,
        storage:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        url: string,
        owner?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchShowBoothItemsQueryVariables = {
  filter?: SearchableShowBoothItemFilterInput | null,
  sort?: SearchableShowBoothItemSortInput | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
};

export type SearchShowBoothItemsQuery = {
  searchShowBoothItems?:  {
    __typename: "SearchableShowBoothItemConnection",
    items:  Array< {
      __typename: "ShowBoothItem",
      id: string,
      name?: string | null,
      title?: string | null,
      readingName?: string | null,
      description?: string | null,
      keyword?: string | null,
      movie?: string | null,
      brand?: string | null,
      price?: number | null,
      boatType?: string | null,
      height?: number | null,
      capacity?: number | null,
      view360?: string | null,
      section?: string | null,
      productUrl?: string | null,
      mapPriority?: number | null,
      badge?: string | null,
      status: Status,
      boothID: string,
      showID: string,
      owner?: string | null,
      version: number,
      priority?: number | null,
      mapIndex?: number | null,
      boothIndex?: number | null,
      boothOrder?: number | null,
      mapOrder?: number | null,
      isExhibition?: boolean | null,
      createdAt: string,
      updatedAt: string,
      photoGallery?:  {
        __typename: "Album",
        id: string,
        name?: string | null,
        owner?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
        phots?:  {
          __typename: "ModelAlbumPhotConnection",
          items:  Array< {
            __typename: "AlbumPhot",
            id: string,
            albumID: string,
            photID: string,
            albumOrder?: number | null,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
      } | null,
      mainImage?:  {
        __typename: "Image",
        id: string,
        alternate: string,
        storage:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        url: string,
        owner?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
      } | null,
      logo?:  {
        __typename: "Image",
        id: string,
        alternate: string,
        storage:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        url: string,
        owner?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
      } | null,
      mapIcon?:  {
        __typename: "Image",
        id: string,
        alternate: string,
        storage:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        url: string,
        owner?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
      } | null,
      thumbnail?:  {
        __typename: "Image",
        id: string,
        alternate: string,
        storage:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        url: string,
        owner?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type GetBoothUserInfoQueryVariables = {
  id: string,
};

export type GetBoothUserInfoQuery = {
  getBoothUserInfo?:  {
    __typename: "BoothUserInfo",
    id: string,
    chatUrl?: string | null,
    chatStatus: Status,
    contactTel?: string | null,
    contactTelInfo?: string | null,
    contactEmail?: string | null,
    contactAddress?: string | null,
    web?: string | null,
    facebook?: string | null,
    boothID: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListBoothUserInfosQueryVariables = {
  filter?: ModelBoothUserInfoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListBoothUserInfosQuery = {
  listBoothUserInfos?:  {
    __typename: "ModelBoothUserInfoConnection",
    items:  Array< {
      __typename: "BoothUserInfo",
      id: string,
      chatUrl?: string | null,
      chatStatus: Status,
      contactTel?: string | null,
      contactTelInfo?: string | null,
      contactEmail?: string | null,
      contactAddress?: string | null,
      web?: string | null,
      facebook?: string | null,
      boothID: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAlbumQueryVariables = {
  id: string,
};

export type GetAlbumQuery = {
  getAlbum?:  {
    __typename: "Album",
    id: string,
    name?: string | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    phots?:  {
      __typename: "ModelAlbumPhotConnection",
      items:  Array< {
        __typename: "AlbumPhot",
        id: string,
        albumID: string,
        photID: string,
        albumOrder?: number | null,
        owner?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
        album?:  {
          __typename: "Album",
          id: string,
          name?: string | null,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          phots?:  {
            __typename: "ModelAlbumPhotConnection",
            nextToken?: string | null,
          } | null,
        } | null,
        phot?:  {
          __typename: "Image",
          id: string,
          alternate: string,
          storage:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          url: string,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type ListAlbumsQueryVariables = {
  filter?: ModelAlbumFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAlbumsQuery = {
  listAlbums?:  {
    __typename: "ModelAlbumConnection",
    items:  Array< {
      __typename: "Album",
      id: string,
      name?: string | null,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      phots?:  {
        __typename: "ModelAlbumPhotConnection",
        items:  Array< {
          __typename: "AlbumPhot",
          id: string,
          albumID: string,
          photID: string,
          albumOrder?: number | null,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          album?:  {
            __typename: "Album",
            id: string,
            name?: string | null,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
          phot?:  {
            __typename: "Image",
            id: string,
            alternate: string,
            url: string,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetBoothBoatTypeQueryVariables = {
  id: string,
};

export type GetBoothBoatTypeQuery = {
  getBoothBoatType?:  {
    __typename: "BoothBoatType",
    id: string,
    name: string,
    priority?: number | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListBoothBoatTypesQueryVariables = {
  filter?: ModelBoothBoatTypeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListBoothBoatTypesQuery = {
  listBoothBoatTypes?:  {
    __typename: "ModelBoothBoatTypeConnection",
    items:  Array< {
      __typename: "BoothBoatType",
      id: string,
      name: string,
      priority?: number | null,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetBoothBoatBrandQueryVariables = {
  id: string,
};

export type GetBoothBoatBrandQuery = {
  getBoothBoatBrand?:  {
    __typename: "BoothBoatBrand",
    id: string,
    name: string,
    priority?: number | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListBoothBoatBrandsQueryVariables = {
  filter?: ModelBoothBoatBrandFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListBoothBoatBrandsQuery = {
  listBoothBoatBrands?:  {
    __typename: "ModelBoothBoatBrandConnection",
    items:  Array< {
      __typename: "BoothBoatBrand",
      id: string,
      name: string,
      priority?: number | null,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAlbumPhotQueryVariables = {
  id: string,
};

export type GetAlbumPhotQuery = {
  getAlbumPhot?:  {
    __typename: "AlbumPhot",
    id: string,
    albumID: string,
    photID: string,
    albumOrder?: number | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    album?:  {
      __typename: "Album",
      id: string,
      name?: string | null,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      phots?:  {
        __typename: "ModelAlbumPhotConnection",
        items:  Array< {
          __typename: "AlbumPhot",
          id: string,
          albumID: string,
          photID: string,
          albumOrder?: number | null,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          album?:  {
            __typename: "Album",
            id: string,
            name?: string | null,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
          phot?:  {
            __typename: "Image",
            id: string,
            alternate: string,
            url: string,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    phot?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type ListAlbumPhotsQueryVariables = {
  filter?: ModelAlbumPhotFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAlbumPhotsQuery = {
  listAlbumPhots?:  {
    __typename: "ModelAlbumPhotConnection",
    items:  Array< {
      __typename: "AlbumPhot",
      id: string,
      albumID: string,
      photID: string,
      albumOrder?: number | null,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      album?:  {
        __typename: "Album",
        id: string,
        name?: string | null,
        owner?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
        phots?:  {
          __typename: "ModelAlbumPhotConnection",
          items:  Array< {
            __typename: "AlbumPhot",
            id: string,
            albumID: string,
            photID: string,
            albumOrder?: number | null,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
      } | null,
      phot?:  {
        __typename: "Image",
        id: string,
        alternate: string,
        storage:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        url: string,
        owner?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetImageQueryVariables = {
  id: string,
};

export type GetImageQuery = {
  getImage?:  {
    __typename: "Image",
    id: string,
    alternate: string,
    storage:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    },
    url: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListImagesQueryVariables = {
  filter?: ModelImageFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListImagesQuery = {
  listImages?:  {
    __typename: "ModelImageConnection",
    items:  Array< {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetShowAudienceQueryVariables = {
  id: string,
};

export type GetShowAudienceQuery = {
  getShowAudience?:  {
    __typename: "ShowAudience",
    id: string,
    showID: string,
    userID: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    show?:  {
      __typename: "Show",
      id: string,
      name: string,
      version: number,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    users?:  {
      __typename: "User",
      id?: string | null,
      identity_id: string,
      email: string,
      group?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      tickets?:  {
        __typename: "ModelTicketConnection",
        items:  Array< {
          __typename: "Ticket",
          id?: string | null,
          status?: TicketStatus | null,
          group?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          activatedUser?:  {
            __typename: "User",
            id?: string | null,
            identity_id: string,
            email: string,
            group?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type ListShowAudiencesQueryVariables = {
  filter?: ModelShowAudienceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListShowAudiencesQuery = {
  listShowAudiences?:  {
    __typename: "ModelShowAudienceConnection",
    items:  Array< {
      __typename: "ShowAudience",
      id: string,
      showID: string,
      userID: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      show?:  {
        __typename: "Show",
        id: string,
        name: string,
        version: number,
        owner?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      users?:  {
        __typename: "User",
        id?: string | null,
        identity_id: string,
        email: string,
        group?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
        tickets?:  {
          __typename: "ModelTicketConnection",
          items:  Array< {
            __typename: "Ticket",
            id?: string | null,
            status?: TicketStatus | null,
            group?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserQueryVariables = {
  identity_id: string,
};

export type GetUserQuery = {
  getUser?:  {
    __typename: "User",
    id?: string | null,
    identity_id: string,
    email: string,
    group?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    tickets?:  {
      __typename: "ModelTicketConnection",
      items:  Array< {
        __typename: "Ticket",
        id?: string | null,
        status?: TicketStatus | null,
        group?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
        activatedUser?:  {
          __typename: "User",
          id?: string | null,
          identity_id: string,
          email: string,
          group?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          tickets?:  {
            __typename: "ModelTicketConnection",
            nextToken?: string | null,
          } | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type ListUsersQueryVariables = {
  identity_id?: string | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListUsersQuery = {
  listUsers?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id?: string | null,
      identity_id: string,
      email: string,
      group?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      tickets?:  {
        __typename: "ModelTicketConnection",
        items:  Array< {
          __typename: "Ticket",
          id?: string | null,
          status?: TicketStatus | null,
          group?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          activatedUser?:  {
            __typename: "User",
            id?: string | null,
            identity_id: string,
            email: string,
            group?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetTicketQueryVariables = {
  id: string,
};

export type GetTicketQuery = {
  getTicket?:  {
    __typename: "Ticket",
    id?: string | null,
    status?: TicketStatus | null,
    group?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    activatedUser?:  {
      __typename: "User",
      id?: string | null,
      identity_id: string,
      email: string,
      group?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      tickets?:  {
        __typename: "ModelTicketConnection",
        items:  Array< {
          __typename: "Ticket",
          id?: string | null,
          status?: TicketStatus | null,
          group?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          activatedUser?:  {
            __typename: "User",
            id?: string | null,
            identity_id: string,
            email: string,
            group?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type ListTicketsQueryVariables = {
  filter?: ModelTicketFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTicketsQuery = {
  listTickets?:  {
    __typename: "ModelTicketConnection",
    items:  Array< {
      __typename: "Ticket",
      id?: string | null,
      status?: TicketStatus | null,
      group?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      activatedUser?:  {
        __typename: "User",
        id?: string | null,
        identity_id: string,
        email: string,
        group?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
        tickets?:  {
          __typename: "ModelTicketConnection",
          items:  Array< {
            __typename: "Ticket",
            id?: string | null,
            status?: TicketStatus | null,
            group?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OnCreateShowSubscriptionVariables = {
};

export type OnCreateShowSubscription = {
  onCreateShow?:  {
    __typename: "Show",
    id: string,
    name: string,
    version: number,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateShowSubscriptionVariables = {
};

export type OnUpdateShowSubscription = {
  onUpdateShow?:  {
    __typename: "Show",
    id: string,
    name: string,
    version: number,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteShowSubscriptionVariables = {
};

export type OnDeleteShowSubscription = {
  onDeleteShow?:  {
    __typename: "Show",
    id: string,
    name: string,
    version: number,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateShowSettingSubscriptionVariables = {
};

export type OnCreateShowSettingSubscription = {
  onCreateShowSetting?:  {
    __typename: "ShowSetting",
    id: string,
    name?: string | null,
    title?: string | null,
    description?: string | null,
    slug?: string | null,
    startDateTime?: string | null,
    endDateTime?: string | null,
    status: Status,
    owner?: string | null,
    showID: string,
    version: number,
    createdAt: string,
    updatedAt: string,
    ogpImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnUpdateShowSettingSubscriptionVariables = {
};

export type OnUpdateShowSettingSubscription = {
  onUpdateShowSetting?:  {
    __typename: "ShowSetting",
    id: string,
    name?: string | null,
    title?: string | null,
    description?: string | null,
    slug?: string | null,
    startDateTime?: string | null,
    endDateTime?: string | null,
    status: Status,
    owner?: string | null,
    showID: string,
    version: number,
    createdAt: string,
    updatedAt: string,
    ogpImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnDeleteShowSettingSubscriptionVariables = {
};

export type OnDeleteShowSettingSubscription = {
  onDeleteShowSetting?:  {
    __typename: "ShowSetting",
    id: string,
    name?: string | null,
    title?: string | null,
    description?: string | null,
    slug?: string | null,
    startDateTime?: string | null,
    endDateTime?: string | null,
    status: Status,
    owner?: string | null,
    showID: string,
    version: number,
    createdAt: string,
    updatedAt: string,
    ogpImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnCreateShowMainSubscriptionVariables = {
};

export type OnCreateShowMainSubscription = {
  onCreateShowMain?:  {
    __typename: "ShowMain",
    id: string,
    title: string,
    mapDiscription?: string | null,
    logoDiscription?: string | null,
    discription?: string | null,
    section?: string | null,
    status: Status,
    showID: string,
    search?: boolean | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnUpdateShowMainSubscriptionVariables = {
};

export type OnUpdateShowMainSubscription = {
  onUpdateShowMain?:  {
    __typename: "ShowMain",
    id: string,
    title: string,
    mapDiscription?: string | null,
    logoDiscription?: string | null,
    discription?: string | null,
    section?: string | null,
    status: Status,
    showID: string,
    search?: boolean | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnDeleteShowMainSubscriptionVariables = {
};

export type OnDeleteShowMainSubscription = {
  onDeleteShowMain?:  {
    __typename: "ShowMain",
    id: string,
    title: string,
    mapDiscription?: string | null,
    logoDiscription?: string | null,
    discription?: string | null,
    section?: string | null,
    status: Status,
    showID: string,
    search?: boolean | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnCreateTeaserSubscriptionVariables = {
};

export type OnCreateTeaserSubscription = {
  onCreateTeaser?:  {
    __typename: "Teaser",
    id: string,
    title: string,
    discription?: string | null,
    countDown?: boolean | null,
    section?: string | null,
    status: Status,
    showID: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnUpdateTeaserSubscriptionVariables = {
};

export type OnUpdateTeaserSubscription = {
  onUpdateTeaser?:  {
    __typename: "Teaser",
    id: string,
    title: string,
    discription?: string | null,
    countDown?: boolean | null,
    section?: string | null,
    status: Status,
    showID: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnDeleteTeaserSubscriptionVariables = {
};

export type OnDeleteTeaserSubscription = {
  onDeleteTeaser?:  {
    __typename: "Teaser",
    id: string,
    title: string,
    discription?: string | null,
    countDown?: boolean | null,
    section?: string | null,
    status: Status,
    showID: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnCreatePageSubscriptionVariables = {
};

export type OnCreatePageSubscription = {
  onCreatePage?:  {
    __typename: "Page",
    id: string,
    root: string,
    slug: string,
    title: string,
    discription?: string | null,
    contents?: string | null,
    status: Status,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnUpdatePageSubscriptionVariables = {
};

export type OnUpdatePageSubscription = {
  onUpdatePage?:  {
    __typename: "Page",
    id: string,
    root: string,
    slug: string,
    title: string,
    discription?: string | null,
    contents?: string | null,
    status: Status,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnDeletePageSubscriptionVariables = {
};

export type OnDeletePageSubscription = {
  onDeletePage?:  {
    __typename: "Page",
    id: string,
    root: string,
    slug: string,
    title: string,
    discription?: string | null,
    contents?: string | null,
    status: Status,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnCreateTopPageSubscriptionVariables = {
};

export type OnCreateTopPageSubscription = {
  onCreateTopPage?:  {
    __typename: "TopPage",
    id: string,
    title: string,
    discription?: string | null,
    contents?: string | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnUpdateTopPageSubscriptionVariables = {
};

export type OnUpdateTopPageSubscription = {
  onUpdateTopPage?:  {
    __typename: "TopPage",
    id: string,
    title: string,
    discription?: string | null,
    contents?: string | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnDeleteTopPageSubscriptionVariables = {
};

export type OnDeleteTopPageSubscription = {
  onDeleteTopPage?:  {
    __typename: "TopPage",
    id: string,
    title: string,
    discription?: string | null,
    contents?: string | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnCreateShowBoothSubscriptionVariables = {
};

export type OnCreateShowBoothSubscription = {
  onCreateShowBooth?:  {
    __typename: "ShowBooth",
    id: string,
    name: string,
    title: string,
    discription?: string | null,
    section?: string | null,
    priority?: number | null,
    status: Status,
    showID: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    brandLogos?:  {
      __typename: "Album",
      id: string,
      name?: string | null,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      phots?:  {
        __typename: "ModelAlbumPhotConnection",
        items:  Array< {
          __typename: "AlbumPhot",
          id: string,
          albumID: string,
          photID: string,
          albumOrder?: number | null,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          album?:  {
            __typename: "Album",
            id: string,
            name?: string | null,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
          phot?:  {
            __typename: "Image",
            id: string,
            alternate: string,
            url: string,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnUpdateShowBoothSubscriptionVariables = {
};

export type OnUpdateShowBoothSubscription = {
  onUpdateShowBooth?:  {
    __typename: "ShowBooth",
    id: string,
    name: string,
    title: string,
    discription?: string | null,
    section?: string | null,
    priority?: number | null,
    status: Status,
    showID: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    brandLogos?:  {
      __typename: "Album",
      id: string,
      name?: string | null,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      phots?:  {
        __typename: "ModelAlbumPhotConnection",
        items:  Array< {
          __typename: "AlbumPhot",
          id: string,
          albumID: string,
          photID: string,
          albumOrder?: number | null,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          album?:  {
            __typename: "Album",
            id: string,
            name?: string | null,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
          phot?:  {
            __typename: "Image",
            id: string,
            alternate: string,
            url: string,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnDeleteShowBoothSubscriptionVariables = {
};

export type OnDeleteShowBoothSubscription = {
  onDeleteShowBooth?:  {
    __typename: "ShowBooth",
    id: string,
    name: string,
    title: string,
    discription?: string | null,
    section?: string | null,
    priority?: number | null,
    status: Status,
    showID: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    brandLogos?:  {
      __typename: "Album",
      id: string,
      name?: string | null,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      phots?:  {
        __typename: "ModelAlbumPhotConnection",
        items:  Array< {
          __typename: "AlbumPhot",
          id: string,
          albumID: string,
          photID: string,
          albumOrder?: number | null,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          album?:  {
            __typename: "Album",
            id: string,
            name?: string | null,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
          phot?:  {
            __typename: "Image",
            id: string,
            alternate: string,
            url: string,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    backgroundImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnCreateShowBoothItemSubscriptionVariables = {
};

export type OnCreateShowBoothItemSubscription = {
  onCreateShowBoothItem?:  {
    __typename: "ShowBoothItem",
    id: string,
    name?: string | null,
    title?: string | null,
    readingName?: string | null,
    description?: string | null,
    keyword?: string | null,
    movie?: string | null,
    brand?: string | null,
    price?: number | null,
    boatType?: string | null,
    height?: number | null,
    capacity?: number | null,
    view360?: string | null,
    section?: string | null,
    productUrl?: string | null,
    mapPriority?: number | null,
    badge?: string | null,
    status: Status,
    boothID: string,
    showID: string,
    owner?: string | null,
    version: number,
    priority?: number | null,
    mapIndex?: number | null,
    boothIndex?: number | null,
    boothOrder?: number | null,
    mapOrder?: number | null,
    isExhibition?: boolean | null,
    createdAt: string,
    updatedAt: string,
    photoGallery?:  {
      __typename: "Album",
      id: string,
      name?: string | null,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      phots?:  {
        __typename: "ModelAlbumPhotConnection",
        items:  Array< {
          __typename: "AlbumPhot",
          id: string,
          albumID: string,
          photID: string,
          albumOrder?: number | null,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          album?:  {
            __typename: "Album",
            id: string,
            name?: string | null,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
          phot?:  {
            __typename: "Image",
            id: string,
            alternate: string,
            url: string,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    mainImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
    logo?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
    mapIcon?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
    thumbnail?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnUpdateShowBoothItemSubscriptionVariables = {
};

export type OnUpdateShowBoothItemSubscription = {
  onUpdateShowBoothItem?:  {
    __typename: "ShowBoothItem",
    id: string,
    name?: string | null,
    title?: string | null,
    readingName?: string | null,
    description?: string | null,
    keyword?: string | null,
    movie?: string | null,
    brand?: string | null,
    price?: number | null,
    boatType?: string | null,
    height?: number | null,
    capacity?: number | null,
    view360?: string | null,
    section?: string | null,
    productUrl?: string | null,
    mapPriority?: number | null,
    badge?: string | null,
    status: Status,
    boothID: string,
    showID: string,
    owner?: string | null,
    version: number,
    priority?: number | null,
    mapIndex?: number | null,
    boothIndex?: number | null,
    boothOrder?: number | null,
    mapOrder?: number | null,
    isExhibition?: boolean | null,
    createdAt: string,
    updatedAt: string,
    photoGallery?:  {
      __typename: "Album",
      id: string,
      name?: string | null,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      phots?:  {
        __typename: "ModelAlbumPhotConnection",
        items:  Array< {
          __typename: "AlbumPhot",
          id: string,
          albumID: string,
          photID: string,
          albumOrder?: number | null,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          album?:  {
            __typename: "Album",
            id: string,
            name?: string | null,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
          phot?:  {
            __typename: "Image",
            id: string,
            alternate: string,
            url: string,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    mainImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
    logo?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
    mapIcon?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
    thumbnail?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnDeleteShowBoothItemSubscriptionVariables = {
};

export type OnDeleteShowBoothItemSubscription = {
  onDeleteShowBoothItem?:  {
    __typename: "ShowBoothItem",
    id: string,
    name?: string | null,
    title?: string | null,
    readingName?: string | null,
    description?: string | null,
    keyword?: string | null,
    movie?: string | null,
    brand?: string | null,
    price?: number | null,
    boatType?: string | null,
    height?: number | null,
    capacity?: number | null,
    view360?: string | null,
    section?: string | null,
    productUrl?: string | null,
    mapPriority?: number | null,
    badge?: string | null,
    status: Status,
    boothID: string,
    showID: string,
    owner?: string | null,
    version: number,
    priority?: number | null,
    mapIndex?: number | null,
    boothIndex?: number | null,
    boothOrder?: number | null,
    mapOrder?: number | null,
    isExhibition?: boolean | null,
    createdAt: string,
    updatedAt: string,
    photoGallery?:  {
      __typename: "Album",
      id: string,
      name?: string | null,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      phots?:  {
        __typename: "ModelAlbumPhotConnection",
        items:  Array< {
          __typename: "AlbumPhot",
          id: string,
          albumID: string,
          photID: string,
          albumOrder?: number | null,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          album?:  {
            __typename: "Album",
            id: string,
            name?: string | null,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
          phot?:  {
            __typename: "Image",
            id: string,
            alternate: string,
            url: string,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    mainImage?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
    logo?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
    mapIcon?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
    thumbnail?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnCreateBoothUserInfoSubscriptionVariables = {
};

export type OnCreateBoothUserInfoSubscription = {
  onCreateBoothUserInfo?:  {
    __typename: "BoothUserInfo",
    id: string,
    chatUrl?: string | null,
    chatStatus: Status,
    contactTel?: string | null,
    contactTelInfo?: string | null,
    contactEmail?: string | null,
    contactAddress?: string | null,
    web?: string | null,
    facebook?: string | null,
    boothID: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateBoothUserInfoSubscriptionVariables = {
};

export type OnUpdateBoothUserInfoSubscription = {
  onUpdateBoothUserInfo?:  {
    __typename: "BoothUserInfo",
    id: string,
    chatUrl?: string | null,
    chatStatus: Status,
    contactTel?: string | null,
    contactTelInfo?: string | null,
    contactEmail?: string | null,
    contactAddress?: string | null,
    web?: string | null,
    facebook?: string | null,
    boothID: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteBoothUserInfoSubscriptionVariables = {
};

export type OnDeleteBoothUserInfoSubscription = {
  onDeleteBoothUserInfo?:  {
    __typename: "BoothUserInfo",
    id: string,
    chatUrl?: string | null,
    chatStatus: Status,
    contactTel?: string | null,
    contactTelInfo?: string | null,
    contactEmail?: string | null,
    contactAddress?: string | null,
    web?: string | null,
    facebook?: string | null,
    boothID: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateAlbumSubscriptionVariables = {
};

export type OnCreateAlbumSubscription = {
  onCreateAlbum?:  {
    __typename: "Album",
    id: string,
    name?: string | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    phots?:  {
      __typename: "ModelAlbumPhotConnection",
      items:  Array< {
        __typename: "AlbumPhot",
        id: string,
        albumID: string,
        photID: string,
        albumOrder?: number | null,
        owner?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
        album?:  {
          __typename: "Album",
          id: string,
          name?: string | null,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          phots?:  {
            __typename: "ModelAlbumPhotConnection",
            nextToken?: string | null,
          } | null,
        } | null,
        phot?:  {
          __typename: "Image",
          id: string,
          alternate: string,
          storage:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          url: string,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnUpdateAlbumSubscriptionVariables = {
};

export type OnUpdateAlbumSubscription = {
  onUpdateAlbum?:  {
    __typename: "Album",
    id: string,
    name?: string | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    phots?:  {
      __typename: "ModelAlbumPhotConnection",
      items:  Array< {
        __typename: "AlbumPhot",
        id: string,
        albumID: string,
        photID: string,
        albumOrder?: number | null,
        owner?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
        album?:  {
          __typename: "Album",
          id: string,
          name?: string | null,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          phots?:  {
            __typename: "ModelAlbumPhotConnection",
            nextToken?: string | null,
          } | null,
        } | null,
        phot?:  {
          __typename: "Image",
          id: string,
          alternate: string,
          storage:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          url: string,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnDeleteAlbumSubscriptionVariables = {
};

export type OnDeleteAlbumSubscription = {
  onDeleteAlbum?:  {
    __typename: "Album",
    id: string,
    name?: string | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    phots?:  {
      __typename: "ModelAlbumPhotConnection",
      items:  Array< {
        __typename: "AlbumPhot",
        id: string,
        albumID: string,
        photID: string,
        albumOrder?: number | null,
        owner?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
        album?:  {
          __typename: "Album",
          id: string,
          name?: string | null,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          phots?:  {
            __typename: "ModelAlbumPhotConnection",
            nextToken?: string | null,
          } | null,
        } | null,
        phot?:  {
          __typename: "Image",
          id: string,
          alternate: string,
          storage:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          url: string,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnCreateBoothBoatTypeSubscriptionVariables = {
};

export type OnCreateBoothBoatTypeSubscription = {
  onCreateBoothBoatType?:  {
    __typename: "BoothBoatType",
    id: string,
    name: string,
    priority?: number | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateBoothBoatTypeSubscriptionVariables = {
};

export type OnUpdateBoothBoatTypeSubscription = {
  onUpdateBoothBoatType?:  {
    __typename: "BoothBoatType",
    id: string,
    name: string,
    priority?: number | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteBoothBoatTypeSubscriptionVariables = {
};

export type OnDeleteBoothBoatTypeSubscription = {
  onDeleteBoothBoatType?:  {
    __typename: "BoothBoatType",
    id: string,
    name: string,
    priority?: number | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateBoothBoatBrandSubscriptionVariables = {
};

export type OnCreateBoothBoatBrandSubscription = {
  onCreateBoothBoatBrand?:  {
    __typename: "BoothBoatBrand",
    id: string,
    name: string,
    priority?: number | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateBoothBoatBrandSubscriptionVariables = {
};

export type OnUpdateBoothBoatBrandSubscription = {
  onUpdateBoothBoatBrand?:  {
    __typename: "BoothBoatBrand",
    id: string,
    name: string,
    priority?: number | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteBoothBoatBrandSubscriptionVariables = {
};

export type OnDeleteBoothBoatBrandSubscription = {
  onDeleteBoothBoatBrand?:  {
    __typename: "BoothBoatBrand",
    id: string,
    name: string,
    priority?: number | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateAlbumPhotSubscriptionVariables = {
};

export type OnCreateAlbumPhotSubscription = {
  onCreateAlbumPhot?:  {
    __typename: "AlbumPhot",
    id: string,
    albumID: string,
    photID: string,
    albumOrder?: number | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    album?:  {
      __typename: "Album",
      id: string,
      name?: string | null,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      phots?:  {
        __typename: "ModelAlbumPhotConnection",
        items:  Array< {
          __typename: "AlbumPhot",
          id: string,
          albumID: string,
          photID: string,
          albumOrder?: number | null,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          album?:  {
            __typename: "Album",
            id: string,
            name?: string | null,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
          phot?:  {
            __typename: "Image",
            id: string,
            alternate: string,
            url: string,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    phot?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnUpdateAlbumPhotSubscriptionVariables = {
};

export type OnUpdateAlbumPhotSubscription = {
  onUpdateAlbumPhot?:  {
    __typename: "AlbumPhot",
    id: string,
    albumID: string,
    photID: string,
    albumOrder?: number | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    album?:  {
      __typename: "Album",
      id: string,
      name?: string | null,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      phots?:  {
        __typename: "ModelAlbumPhotConnection",
        items:  Array< {
          __typename: "AlbumPhot",
          id: string,
          albumID: string,
          photID: string,
          albumOrder?: number | null,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          album?:  {
            __typename: "Album",
            id: string,
            name?: string | null,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
          phot?:  {
            __typename: "Image",
            id: string,
            alternate: string,
            url: string,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    phot?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnDeleteAlbumPhotSubscriptionVariables = {
};

export type OnDeleteAlbumPhotSubscription = {
  onDeleteAlbumPhot?:  {
    __typename: "AlbumPhot",
    id: string,
    albumID: string,
    photID: string,
    albumOrder?: number | null,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    album?:  {
      __typename: "Album",
      id: string,
      name?: string | null,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      phots?:  {
        __typename: "ModelAlbumPhotConnection",
        items:  Array< {
          __typename: "AlbumPhot",
          id: string,
          albumID: string,
          photID: string,
          albumOrder?: number | null,
          owner?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          album?:  {
            __typename: "Album",
            id: string,
            name?: string | null,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
          phot?:  {
            __typename: "Image",
            id: string,
            alternate: string,
            url: string,
            owner?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    phot?:  {
      __typename: "Image",
      id: string,
      alternate: string,
      storage:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      url: string,
      owner?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnCreateImageSubscriptionVariables = {
};

export type OnCreateImageSubscription = {
  onCreateImage?:  {
    __typename: "Image",
    id: string,
    alternate: string,
    storage:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    },
    url: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateImageSubscriptionVariables = {
};

export type OnUpdateImageSubscription = {
  onUpdateImage?:  {
    __typename: "Image",
    id: string,
    alternate: string,
    storage:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    },
    url: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteImageSubscriptionVariables = {
};

export type OnDeleteImageSubscription = {
  onDeleteImage?:  {
    __typename: "Image",
    id: string,
    alternate: string,
    storage:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    },
    url: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateShowAudienceSubscriptionVariables = {
};

export type OnCreateShowAudienceSubscription = {
  onCreateShowAudience?:  {
    __typename: "ShowAudience",
    id: string,
    showID: string,
    userID: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    show?:  {
      __typename: "Show",
      id: string,
      name: string,
      version: number,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    users?:  {
      __typename: "User",
      id?: string | null,
      identity_id: string,
      email: string,
      group?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      tickets?:  {
        __typename: "ModelTicketConnection",
        items:  Array< {
          __typename: "Ticket",
          id?: string | null,
          status?: TicketStatus | null,
          group?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          activatedUser?:  {
            __typename: "User",
            id?: string | null,
            identity_id: string,
            email: string,
            group?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateShowAudienceSubscriptionVariables = {
};

export type OnUpdateShowAudienceSubscription = {
  onUpdateShowAudience?:  {
    __typename: "ShowAudience",
    id: string,
    showID: string,
    userID: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    show?:  {
      __typename: "Show",
      id: string,
      name: string,
      version: number,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    users?:  {
      __typename: "User",
      id?: string | null,
      identity_id: string,
      email: string,
      group?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      tickets?:  {
        __typename: "ModelTicketConnection",
        items:  Array< {
          __typename: "Ticket",
          id?: string | null,
          status?: TicketStatus | null,
          group?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          activatedUser?:  {
            __typename: "User",
            id?: string | null,
            identity_id: string,
            email: string,
            group?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteShowAudienceSubscriptionVariables = {
};

export type OnDeleteShowAudienceSubscription = {
  onDeleteShowAudience?:  {
    __typename: "ShowAudience",
    id: string,
    showID: string,
    userID: string,
    owner?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    show?:  {
      __typename: "Show",
      id: string,
      name: string,
      version: number,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    users?:  {
      __typename: "User",
      id?: string | null,
      identity_id: string,
      email: string,
      group?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      tickets?:  {
        __typename: "ModelTicketConnection",
        items:  Array< {
          __typename: "Ticket",
          id?: string | null,
          status?: TicketStatus | null,
          group?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          activatedUser?:  {
            __typename: "User",
            id?: string | null,
            identity_id: string,
            email: string,
            group?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateUserSubscriptionVariables = {
};

export type OnCreateUserSubscription = {
  onCreateUser?:  {
    __typename: "User",
    id?: string | null,
    identity_id: string,
    email: string,
    group?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    tickets?:  {
      __typename: "ModelTicketConnection",
      items:  Array< {
        __typename: "Ticket",
        id?: string | null,
        status?: TicketStatus | null,
        group?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
        activatedUser?:  {
          __typename: "User",
          id?: string | null,
          identity_id: string,
          email: string,
          group?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          tickets?:  {
            __typename: "ModelTicketConnection",
            nextToken?: string | null,
          } | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnUpdateUserSubscriptionVariables = {
};

export type OnUpdateUserSubscription = {
  onUpdateUser?:  {
    __typename: "User",
    id?: string | null,
    identity_id: string,
    email: string,
    group?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    tickets?:  {
      __typename: "ModelTicketConnection",
      items:  Array< {
        __typename: "Ticket",
        id?: string | null,
        status?: TicketStatus | null,
        group?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
        activatedUser?:  {
          __typename: "User",
          id?: string | null,
          identity_id: string,
          email: string,
          group?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          tickets?:  {
            __typename: "ModelTicketConnection",
            nextToken?: string | null,
          } | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnDeleteUserSubscriptionVariables = {
};

export type OnDeleteUserSubscription = {
  onDeleteUser?:  {
    __typename: "User",
    id?: string | null,
    identity_id: string,
    email: string,
    group?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    tickets?:  {
      __typename: "ModelTicketConnection",
      items:  Array< {
        __typename: "Ticket",
        id?: string | null,
        status?: TicketStatus | null,
        group?: string | null,
        version: number,
        createdAt: string,
        updatedAt: string,
        activatedUser?:  {
          __typename: "User",
          id?: string | null,
          identity_id: string,
          email: string,
          group?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          tickets?:  {
            __typename: "ModelTicketConnection",
            nextToken?: string | null,
          } | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnCreateTicketSubscriptionVariables = {
};

export type OnCreateTicketSubscription = {
  onCreateTicket?:  {
    __typename: "Ticket",
    id?: string | null,
    status?: TicketStatus | null,
    group?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    activatedUser?:  {
      __typename: "User",
      id?: string | null,
      identity_id: string,
      email: string,
      group?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      tickets?:  {
        __typename: "ModelTicketConnection",
        items:  Array< {
          __typename: "Ticket",
          id?: string | null,
          status?: TicketStatus | null,
          group?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          activatedUser?:  {
            __typename: "User",
            id?: string | null,
            identity_id: string,
            email: string,
            group?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateTicketSubscriptionVariables = {
};

export type OnUpdateTicketSubscription = {
  onUpdateTicket?:  {
    __typename: "Ticket",
    id?: string | null,
    status?: TicketStatus | null,
    group?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    activatedUser?:  {
      __typename: "User",
      id?: string | null,
      identity_id: string,
      email: string,
      group?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      tickets?:  {
        __typename: "ModelTicketConnection",
        items:  Array< {
          __typename: "Ticket",
          id?: string | null,
          status?: TicketStatus | null,
          group?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          activatedUser?:  {
            __typename: "User",
            id?: string | null,
            identity_id: string,
            email: string,
            group?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteTicketSubscriptionVariables = {
};

export type OnDeleteTicketSubscription = {
  onDeleteTicket?:  {
    __typename: "Ticket",
    id?: string | null,
    status?: TicketStatus | null,
    group?: string | null,
    version: number,
    createdAt: string,
    updatedAt: string,
    activatedUser?:  {
      __typename: "User",
      id?: string | null,
      identity_id: string,
      email: string,
      group?: string | null,
      version: number,
      createdAt: string,
      updatedAt: string,
      tickets?:  {
        __typename: "ModelTicketConnection",
        items:  Array< {
          __typename: "Ticket",
          id?: string | null,
          status?: TicketStatus | null,
          group?: string | null,
          version: number,
          createdAt: string,
          updatedAt: string,
          activatedUser?:  {
            __typename: "User",
            id?: string | null,
            identity_id: string,
            email: string,
            group?: string | null,
            version: number,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};
